export const translations = {
  en: {
    title: "WaveBudget Tracker",
    logout: "Logout",
    addNewExpense: "Add New Expense",
    editExpense: "Edit Expense",
    hideForm: "Hide Form",
    expenseName: "Expense Name",
    amount: "Amount ($)",
    dueDate: "Due Date",
    category: "Pay Period",
    waveCategory: "Wave (Biweekly Paychecks)",
    paycheckCategory: "Paycheck",
    otherCategory: "Other",
    paymentWeek: "Payment Week",
    paymentWave: "Payment Wave",
    paymentFrequency: "Payment Frequency",
    weekly: "Weekly (4 Weeks)",
    biweekly: "Biweekly (2 Waves)",
    monthly: "Monthly (1 Wave)",
    paymentType: "Payment Type",
    web: "Web",
    app: "App",
    autopay: "Autopay",
    paymentUrl: "Payment URL (optional)",
    addExpense: "Add Expense",
    updateExpense: "Update Expense",
    cancel: "Cancel",
    expenseListSetup: "Expense List Setup",
    waveAmount: "Wave Amount ($)",
    expenseList: "Expense List",
    searchExpenses: "Search expenses...",
    all: "All",
    noExpenses: "No expenses yet. Add your first expense above!",
    expenseNameHeader: "Expense Name",
    amountHeader: "Amount",
    dueDayHeader: "Due Day",
    categoryHeader: "Category",
    statusHeader: "Status",
    payHeader: "Pay",
    actionsHeader: "Actions",
    paid: "Paid",
    unpaid: "Unpaid",
    resetAllUnpaid: "Reset all to unpaid",
    switchTheme: (theme: string) =>
      `Switch to ${theme === "light" ? "dark" : "light"} mode`,
    payVia: (type: string) => `Pay via ${type}`,
    noPaymentUrl: "No payment URL available",
    settings: "Settings",
    manageIncome: "Manage Income",
    saveSettings: "Save Settings",
    hideSettings: "Hide Settings",
    language: "Language",
    english: "English",
    spanish: "Spanish",
    aiAdvisor: "Wavey AI Financial Advisor",
    aiAdvisorPlaceholder: "Ask me anything about your budget...",
    aiAdvisorThinking: "AI is thinking...",
    aiAdvisorError: "Failed to get AI response. Please try again.",
    sendMessage: "Send message",
    closeAdvisor: "Close advisor",
    week: (num: number) => `Week ${num}`,
    wave: (num: number) => `Wave ${num}`,
    totalUnpaidWaveExpenses: "Total Expenses",
    totalWaves: "Total Waves",
    otherUnpaidExpenses: "Other Unpaid Expenses",
    expenses: (count: number) => `Expenses: $${count.toFixed(2)}`,
    balance: (amount: number) => `Balance: $${amount.toFixed(2)}`,
    total: (amount: number, count: number) =>
      `Total: $${amount.toFixed(2)} (${count} items)`,
    items: "items",
    delete: "Delete",
    loading: "Loading...",
    manageIncomeSources: "Manage Income Sources",
    hideIncomeSources: "Hide Income Sources",
    incomeName: "Income Name",
    incomeAmount: "Amount",
    incomeFrequency: "Frequency",
    nextPaymentDate: "Next Payment Date (Optional)",
    addIncome: "Add Income",
    updateIncome: "Update Income",
    yourIncomeSources: "Your Income Sources:",
    incomeAdded: "Income added!",
    incomeUpdated: "Income updated!",
    incomeDeleted: "Income deleted!",
    deleteIncomeConfirm: "Delete this income source?",
    totalMonthlyIncome: "Total Monthly Income",
    incomeTracking:
      "Track multiple income sources like salary, gig work, freelance, etc.",
    expenseNameTooltip:
      "Enter the name of your bill or expense (e.g., Netflix, Rent, Car Payment)",
    amountTooltip: "Enter the exact amount you pay for this expense",
    categoryTooltip:
      "Wave: Paid from your regular paycheck | Paycheck: Additional income sources | Other: One-time expenses",
    paymentUrlTooltip:
      "Enter the website/app link where you pay this bill. Leave blank if autopay.",
    recurringExpense: "This is a recurring expense",
    recurringExpenseTooltip:
      "Check this if the expense repeats regularly (e.g., Netflix, rent, utilities). You can reset all recurring expenses at once when starting a new billing cycle.",
    howOften: "How often?",
    frequencyWeekly: "Weekly",
    frequencyBiweekly: "Every 2 Weeks",
    frequencyMonthly: "Monthly",
    frequencyQuarterly: "Every 3 Months (Quarterly)",
    frequencySemiAnnual: "Every 6 Months (Semi-Annual)",
    frequencyAnnual: "Once a Year (Annual)",
    recurringBadgeWeekly: "Wkly",
    recurringBadgeBiweekly: "2wk",
    recurringBadgeMonthly: "Mo",
    recurringBadgeQuarterly: "3mo",
    recurringBadgeSemiAnnual: "6mo",
    recurringBadgeAnnual: "Yearly",
    recurringBadgeWeeklyFull: "Weekly",
    recurringBadgeBiweeklyFull: "Bi-weekly",
    recurringBadgeMonthlyFull: "Monthly",
    recurringBadgeQuarterlyFull: "Quarterly",
    recurringBadgeSemiAnnualFull: "Every 6 months",
    recurringBadgeAnnualFull: "Yearly",
    noRecurringExpensesToReset: "No paid recurring expenses to reset",
    noExpensesToReset: "No paid expenses to reset",
    resetRecurringExpensesConfirm: (count: number) =>
      `Reset ${count} recurring expenses for new cycle? (One-time expenses will stay as is)`,
    recurringExpensesResetSuccess: (count: number) =>
      `${count} recurring expenses reset successfully!`,
    // Quick Add feature
    quickAdd: "Quick Add",
    quickAddCommonExpenses: "Quick Add Common Expenses",
    quickAddDescription: "Select from popular expenses and add them instantly",
    selectTemplates: "Select templates to add",
    categoryStreaming: "📺 Streaming",
    categoryHousing: "🏠 Housing",
    categoryUtilities: "💡 Utilities",
    categoryTransportation: "🚗 Transportation",
    categorySubscriptions: "📱 Subscriptions",
    categoryInsurance: "🛡️ Insurance",
    categoryFood: "🍔 Food",
    reviewAndCustomize: "Review & Customize",
    backToTemplates: "Back to Templates",
    addSelected: (count: number) => `Add Selected (${count})`,
    reviewSelected: "Review Selected",
    templatesSelected: (count: number) =>
      `${count} ${count === 1 ? "template" : "templates"} selected`,
    editDetails: "Edit",
    removeTemplate: "Remove",
    amountRequired: "Amount required",
    enterAmount: "Enter amount",
    templateAddedSuccess: (count: number) =>
      `${count} ${count === 1 ? "expense" : "expenses"} added successfully!`,
    noTemplatesSelected:
      "No templates selected. Please select at least one template.",
    missingRequiredFields: (count: number) =>
      `${count} ${count === 1 ? "template needs" : "templates need"} amount`,
    fillRequiredFields: "Fill Required Fields",
    allTemplatesAdded:
      "All common expenses have been added! You can add custom expenses using the regular form.",
    dataVisualization: "Data Visualization",
    expenseBreakdown: "Expense Breakdown",
    waveBalances: "Wave Balances",
    spendingTrends: "Spending Trends (30 Days)",
    topExpenses: "Top 5 Expenses",
    incomeVsExpenses: "Income vs Expenses",
    spendingPatterns: "Spending Patterns",
    balanceForecast: "Balance Forecast (3 Months)",
    upgradeForCharts: "Upgrade to unlock advanced analytics",
    premiumFeature: "Premium Feature",
    standardFeature: "Standard Feature",
    waveText: "Wave",
    other: "Other",
    balanceText: "Balance",
    income: "Income",
    expensesText: "Expenses",
    temporalCategory: "Temporal (Biweekly Payments)",
    bankLinking: "Bank Linking",
    linkBankAccount: "Link Bank Account",
    premiumRequiredForBankLink:
      "Premium subscription required to link bank accounts",
    // Settings page
    settingsPage: {
      totalWaveAmount: "Total Wave Amount",
      sumOfAllWaves: "This is the sum of all your wave amounts below",
      week1Amount: "Week 1 Amount",
      week2Amount: "Week 2 Amount",
      week3Amount: "Week 3 Amount",
      week4Amount: "Week 4 Amount",
      wave1Amount: "Wave 1 Amount",
      wave2Amount: "Wave 2 Amount",
      totalMonthlyIncome: "Total Monthly Income",
      mainIncome: "Main Income",
      additionalSources: "Additional Sources",
      allIncomeSources: "All Income Sources",
      waveIncome: "Wave Income",
      paycheck: "Paycheck",
      mainIncomeLabel: "Main Income",
      primary: "PRIMARY",
      mainIncomeColor: "Main income colour",
      save: "Save",
      hideAdditionalSources: "Hide Additional Sources",
      addAdditionalSources: "Add Additional Sources",
      extraIncomeHint:
        "Add extra income sources like gig work, freelance, bonuses, etc.",
      incomeLimit: (current: number, max: number | string) =>
        `${current} / ${max}`,
      freeIncomeLimit: "Free: Main income only",
      standardIncomeLimit: "Standard: Main + 2 sources",
      premiumIncomeLimit: "Premium: Unlimited sources",
      incomeName: "Income Name",
      incomeNamePlaceholder: "e.g., Uber, Freelance",
      amount: "Amount",
      frequency: "Frequency",
      weekly: "Weekly",
      biweekly: "Bi-weekly",
      monthly: "Monthly",
      oneTime: "One-time",
      nextPaymentOptional: "Next Payment (Optional)",
      color: "Color",
      addIncome: "Add Income",
      appPreferences: "App Preferences",
      hideThemeColors: "Hide Theme Colors",
      customizeThemeColors: "Customize Theme Colors",
      themeColorsHint:
        "Choose from free presets or create custom colors with Premium",
      themePresetFree: "Theme Preset (Free)",
      blue: "Blue",
      green: "Green",
      purple: "Purple",
      customColorsPremium: "Custom Colors (Premium)",
      premiumOnly: "Premium Only",
      primaryColor: "Primary Color",
      primaryDark: "Primary Dark",
      applyCustomColors: "Apply Custom Colors",
      upgradePremiumCustomColors:
        "Upgrade to Premium to unlock custom theme colors!",
      saveThemeColors: "Save Theme Colors",
      currentPlan: "Current Plan",
      upgradeUnlockColors: "Upgrade to unlock custom colors",
      upgradeNow: "Upgrade Now",
      profileDetails: "Profile Details",
      firstName: "First Name",
      lastName: "Last Name",
      emailAddress: "Email Address",
      profileImage: "Profile Image",
      chooseImage: "Choose Image",
      currentImage: "Current image",
      maxSizeSupported: "Max size: 5MB. Supported: JPG, PNG, GIF",
      profileImageUploaded: "Profile image uploaded",
      noImageUploaded: "No image uploaded",
      saveChanges: "Save Changes",
      changePassword: "Change Password",
      currentPassword: "Current Password",
      newPassword: "New Password",
      confirmNewPassword: "Confirm New Password",
      passwordMinLength: "Must be at least 8 characters",
      updatePassword: "Update Password",
      clickLockToChangePassword: "Click the lock icon to change your password",
      familySharing: "Family Sharing",
      shareBudgetFamily: "Share your budget with up to 3 family members",
      deleteIncome: "Delete Income",
      deleteIncomeConfirmation:
        "Are you sure you want to delete this income source?",
      confirm: "Confirm",
      upgradeRequired: "Upgrade Required",
      familyMember: "Family Member",
      youArePartOf: "You are part of",
      leaveFamilyButton: "Leave Family",
      familyMembers: "Family Members",
      inviteFamilyMember: "Invite Family Member",
      memberEmailAddress: "Email Address",
      partnerExample: "partner@example.com",
      sendInvite: "Send Invite",
      active: "Active",
      pending: "Pending",
      removeFamilyMember: "Remove this family member?",
      memberRemoved: "Member removed",
      failedToRemoveMember: "Failed to remove member",
      leftFamilyAccount: "Left family account",
      failedToLeaveFamily: "Failed to leave family",
      removeFamilyConfirm: "Remove this family member?",
      leaveFamilyConfirm: "Leave this family account?",
      invitationSent: "Invitation sent!",
      failedToSendInvitation: "Failed to send invitation",
      members: "Members",
      youCanAddMore: (count: number) =>
        `You can add ${count} more member${count > 1 ? "s" : ""}`,
      maximumMembersReached: "Maximum members reached",
      membersCount: (current: number, max: number) =>
        `${current} / ${max} Members`,
      upgradeAddMoreSources: "Upgrade to add more sources?",
      customThemeRequiresPremium:
        "Custom theme colors require Premium subscription",
      customColorsRequirePremium: "Custom colors require Premium. Upgrade now!",
      themeColorsSaved: "Theme colors saved!",
      limitReachedFree: "Limit reached! Standard adds 2 sources",
      limitReachedStandard: "Limit reached! Premium = unlimited",
      enterFirstName: "Enter your first name",
      enterLastName: "Enter your last name",
      enterEmail: "Enter your email",
      imageLessThan5MB: "Image must be less than 5MB",
      pleaseSelectImage: "Please select an image file",
      failedReadImage: "Failed to read image file",
      profileUpdatedSuccess: "Profile updated successfully!",
      failedUpdateProfile: "Failed to update profile",
      passwordsDoNotMatch: "Passwords do not match",
      passwordMinLengthError: "Password must be at least 8 characters",
      passwordUpdatedSuccess: "Password updated successfully!",
      failedUpdatePassword: "Failed to update password",
      // Email notifications
      emailNotifications: "Email Notifications",
      emailNotificationsInfo:
        "Email notifications will be sent to your registered email address",
      notificationsSaved: "Notification preferences saved",
      expenseReminders: "Expense Reminders",
      expenseRemindersDesc: "Get notified when bills are due",
      paymentAlerts: "Payment Alerts",
      paymentAlertsDesc: "Notifications when payments are made",
      budgetAlerts: "Budget Alerts",
      budgetAlertsDesc: "Alert when approaching budget limits",
      weeklySummary: "Weekly Summary",
      weeklySummaryDesc: "Receive weekly budget summaries",
      familyActivity: "Family Activity",
      familyActivityDesc: "Notifications for family member actions",
      saveNotifications: "Save Notifications",
      failedToSaveNotifications: "Failed to save notification preferences",
      free: "FREE",
      standard: "STANDARD",
      premium: "PREMIUM",
      // Cookie Preferences
      cookiePreferences: "Cookie Preferences",
      cookiePreferencesDesc:
        "Manage your cookie preferences. Some cookies are essential for the website to function, while others help us improve your experience.",
      functionalCookies: "Functional Cookies",
      functionalCookiesDesc:
        "Essential for authentication, session management, and basic site functionality.",
      analyticsCookies: "Analytics Cookies",
      analyticsCookiesDesc:
        "Help us understand how you use the site and improve your experience through Google Analytics.",
      marketingCookies: "Marketing Cookies",
      marketingCookiesDesc:
        "Used to show you relevant ads and content. Optional and can be disabled at any time.",
      requiredBadge: "Required",
      cannotBeDisabled: "These cookies cannot be disabled",
      howToReset: "How to reset:",
      resetInstructions:
        "Clear your browser's cookies and localStorage to see the cookie consent banner again. You can then update your preferences.",
      viewCookiePolicy: "View our Cookie Policy",
      replayOnboarding: "Replay Onboarding Tour",
      takeATour: "Take the Onboarding Tour",
    },
    // Cookie Policy page
    cookiePolicy: {
      title: "Cookie Policy",
      lastUpdated: "Last Updated",
      backToSettings: "Back to Settings",
      whatAreCookies: "What Are Cookies?",
      whatAreCookiesDesc:
        "Cookies are small text files that are stored on your device (computer, tablet, or mobile phone) when you visit a website. They help websites recognize you, remember your preferences, and provide you with a better experience.",
      howWeUseCookies: "How We Use Cookies",
      howWeUseCookiesDesc:
        "Budget Tracker uses cookies for several essential and beneficial purposes:",
      functionalCookiesTitle: "Functional Cookies (Required)",
      functionalCookiesIntro:
        "These cookies are essential for the website to function properly. They are used to:",
      functionalList1: "Keep you logged in to your account",
      functionalList2: "Remember your preferences and settings",
      functionalList3: "Maintain your session",
      functionalList4: "Enable secure communication",
      functionalList5: "Prevent fraud and abuse",
      functionalRequired: "These cookies cannot be disabled",
      functionalRequiredDesc:
        "as they are necessary for the site to function. You can control them through your browser settings, but this may affect your ability to use the site.",
      analyticsCookiesTitle: "Analytics Cookies (Optional)",
      analyticsCookiesIntro:
        "We use Google Analytics to understand how you use our website. These cookies collect:",
      analyticsList1: "Pages you visit",
      analyticsList2: "Time spent on pages",
      analyticsList3: "User behavior patterns",
      analyticsList4: "Performance metrics",
      analyticsList5: "Device and browser information",
      analyticsNoPersonalData:
        "No personal data is collected through analytics cookies.",
      analyticsAnonymized:
        "All data is anonymized and used only to improve our services. You can opt out of analytics cookies at any time in your cookie preferences or through the Google Analytics opt-out browser extension.",
      marketingCookiesTitle: "Marketing Cookies (Optional)",
      marketingCookiesIntro:
        "These cookies help us show you relevant content and ads based on your interests. They may be used by:",
      marketingList1: "Advertising partners",
      marketingList2: "Social media platforms",
      marketingList3: "Retargeting services",
      marketingNoPersonalData: "No personal data is shared with advertisers.",
      marketingOptOut:
        "You can disable these cookies anytime in your cookie preferences.",
      thirdPartyCookies: "Third-Party Cookies",
      thirdPartyCookiesDesc:
        "We may use cookies from trusted third-party services to enhance your experience:",
      googleAnalyticsDesc: "Helps us understand site usage patterns",
      sentryDesc: "Monitors application performance and errors",
      stripeDesc: "Processes secure payments (if applicable)",
      otherPartners: "Other Partners",
      otherPartnersDesc: "May include advertising and analytics partners",
      thirdPartyPrivacy:
        "These partners have their own privacy policies and may use cookies to track you across websites.",
      cookieRetention: "Cookie Retention",
      cookieRetentionDesc:
        "Cookies are retained for different periods depending on their purpose:",
      sessionCookies: "Session Cookies",
      sessionCookiesDesc: "Deleted when you close your browser",
      persistentCookies: "Persistent Cookies",
      persistentCookiesDesc:
        "Remain for up to 2 years or until you delete them",
      analyticsCookiesRetention: "Analytics Cookies",
      analyticsCookiesRetentionDesc:
        "Retained for analysis and deleted within 26 months",
      howToControl: "How to Control Cookies",
      usingCookieSettings: "Using Budget Tracker Cookie Settings",
      usingCookieSettingsDesc:
        "You can control your cookie preferences anytime by:",
      controlStep1: "Going to Settings → Cookie Preferences",
      controlStep2: "Toggling analytics and marketing cookies on or off",
      controlStep3: 'Clicking "Save Preferences"',
      usingBrowser: "Using Your Browser",
      usingBrowserDesc:
        "You can also control cookies through your browser settings:",
      chromeInstructions:
        "Settings → Privacy and security → Cookies and other site data",
      firefoxInstructions:
        "Preferences → Privacy & Security → Cookies and Site Data",
      safariInstructions: "Preferences → Privacy → Cookies and website data",
      edgeInstructions:
        "Settings → Privacy, search, and services → Cookies and other site data",
      note: "Note",
      disablingFunctional:
        "Disabling functional cookies may prevent the site from working properly.",
      optOutAnalytics: "Opt Out of Analytics",
      optOutAnalyticsDesc: "To opt out of Google Analytics tracking, you can:",
      optOutOption1: "Use the Google Analytics opt-out browser extension",
      optOutOption2: "Disable analytics cookies in our cookie preferences",
      optOutOption3: 'Enable "Do Not Track" in your browser settings',
      privacyRights: "Your Privacy Rights",
      privacyRightsDesc:
        "Under GDPR, CCPA, PIPEDA, and other privacy laws, you have the right to:",
      rightAccess: "Access",
      rightAccessDesc: "Know what cookies we use",
      rightConsent: "Consent",
      rightConsentDesc: "Choose which cookies to accept",
      rightWithdraw: "Withdraw",
      rightWithdrawDesc: "Withdraw consent at any time",
      rightDelete: "Delete",
      rightDeleteDesc: "Request deletion of your data",
      rightPortability: "Portability",
      rightPortabilityDesc: "Export your data in a portable format",
      exerciseRights: "To exercise any of these rights, please contact us at",
      changesToPolicy: "Changes to This Policy",
      changesToPolicyDesc:
        'We may update this Cookie Policy from time to time to reflect changes in technology, laws, or our practices. We will notify you of material changes by posting the updated policy on our website and updating the "Last Updated" date above.',
      contactUs: "Contact Us",
      contactUsDesc:
        "If you have questions about our use of cookies or this policy, please contact us at:",
      email: "Email",
      website: "Website",
      compliance: "Compliance & Standards",
      complianceDesc: "Our cookie practices comply with:",
      gdpr: "General Data Protection Regulation (GDPR) - EU",
      ccpa: "California Consumer Privacy Act (CCPA) - USA",
      pipeda:
        "Personal Information Protection and Electronic Documents Act (PIPEDA) - Canada",
      ePrivacy: "ePrivacy Directive - EU Member States",
      canSpam: "CAN-SPAM Act - USA",
    },
    // Auth page
    authPage: {
      accountCreatedSuccess:
        "Account created! Please check your email to verify your account.",
      welcomeBack: "Welcome Back",
      createAccount: "Create Account",
      signInToContinue: "Sign in to continue",
      signUpToGetStarted: "Sign up to get started",
      firstName: "First Name",
      lastName: "Last Name",
      emailAddress: "Email Address",
      password: "Password",
      reenterPassword: "Re-enter Password",
      signIn: "Sign In",
      or: "or",
      authenticating: "Authenticating...",
      signInWithBiometric: "Sign in with Face ID / Touch ID",
      needAccount: "Need an account? Sign Up",
      alreadyHaveAccount: "Already have an account? Sign In",
      forgotPassword: "Forgot Password?",
      hidePassword: "Hide password",
      showPassword: "Show password",
      pleaseEnterEmail: "Please enter your email address first",
      resetLinkSent: "Reset link sent to your email!",
      failedToSendResetLink: "Failed to send reset link",
      enterVerificationCode: "Enter verification code",
      mfaCodeLabel: "Code",
      verifyCode: "Verify",
      cancelBtn: "Cancel",
      resendCodeBtn: "Resend code",
      rememberDevice: "Remember this device for 30 days",
      signInWithGoogle: "Sign in with Google",
      resetPasswordBtn: "Reset Password",
    },
    // Editable wave amount
    editableWave: {
      invalidAmount: "Invalid amount",
      failedToSave: "Failed to save",
    },
    // Navbar
    navbar: {
      dashboard: "Dashboard",
      expenses: "Expenses",
      settings: "Settings",
      subscription: "Subscription",
      reset: "Reset",
      resetTooltip: "Reset all expenses to unpaid to start new billing cycle",
      export: "Export",
      email: "Email",
      banks: "Bank(s)",
      syncing: "Syncing...",
      sync: "Sync",
      linkBank: "Link Bank",
      waveyAI: "Wavey AI",
      planner: "Planner",
      notifications: "Notifications",
      theme: "Theme",
      language: "Language",
      logout: "Logout",
    },
    sidebar: {
      navigation: "Navigation",
      tools: "Tools",
      actions: "Actions",
      reports: "Reports",
      reimbursements: "Reimbursements",
      notes: "Notes",
    },
    notesPage: {
      title: "Notes",
      subtitle: "Track monthly notes about your budget",
      addNote: "Add a note",
      addButton: "Add",
      placeholder: "e.g. Overspent $90 on wave 1",
      previousMonth: "Previous month",
      nextMonth: "Next month",
      emptyState: "No notes yet for this month. Add one above.",
      added: "Note added",
      addFailed: "Failed to add note",
      updated: "Note updated",
      updateFailed: "Failed to update note",
      deleted: "Note deleted",
      deleteFailed: "Failed to delete note",
      deleteTitle: "Delete note?",
      deleteConfirm: "This note will be permanently deleted.",
      cancel: "Cancel",
      save: "Save",
      edit: "Edit",
      delete: "Delete",
    },
    reimbursementsPage: {
      title: "Reimbursements",
      subtitle: "Track credit card expenses owed to you",
      markReimbursable: "Mark as Reimbursable",
      unmark: "Unmark",
      whoOwes: "Who owes you?",
      deadline: "Deadline",
      statusPending: "Pending",
      statusSubmitted: "Submitted",
      statusReceived: "Received",
      downloadPdf: "Download PDF",
      exportEmail: "Export via Email",
      exportSent: "Email sent!",
      exportError: "Failed to send email",
      totalOutstanding: "Total Outstanding",
      totalReceived: "Total Received",
      items: "Items",
      filterAll: "All Transactions",
      filterPending: "To Collect",
      filterReceived: "Received",
      emptyNoCreditCard: "No linked credit card transactions",
      emptyNoCreditCardSub: "Link a bank account with a credit card to start tracking reimbursements",
      emptyFiltered: "No reimbursements in this category",
      editDetails: "Edit Details",
      saveDetails: "Save",
      cancel: "Cancel",
      selectToExport: "Select items to export",
      noneSelected: "Select at least one item",
      failedToUpdate: "Failed to update",
      failedToSave: "Failed to save",
    },
    planner: {
      title: "Planner",
      subtitle: "Track your financial goals and payment plans",
      addItem: "Add Plan Item",
      editItem: "Edit Plan Item",
      noItems: "No plan items yet",
      noItemsSubtitle: "Add your first financial goal or payment plan",
      itemTitle: "Title",
      itemTitlePlaceholder: "e.g. Pay extra on Chase Freedom",
      amount: "Amount",
      targetDate: "Target Date",
      targetDatePlaceholder: "e.g. 05/2025",
      type: "Type",
      status: "Status",
      notes: "Notes",
      notesPlaceholder: "Optional notes...",
      payExtra: "Pay Extra",
      save: "Save",
      transfer: "Transfer",
      milestone: "Milestone",
      pending: "Pending",
      inProgress: "In Progress",
      completed: "Completed",
      skipped: "Skipped",
      all: "All",
      deleteConfirm: "Delete this plan item?",
      deleteSuccess: "Plan item deleted",
      saveSuccess: "Plan item saved",
      markDone: "Mark as Done",
      waveyTip: "Looks like you're paying the minimum on",
      waveyTipSuffix: "— paying a little extra frees up credit faster.",
      addToPlannerCta: "Add to Planner",
      waveySuggests: "Wavey suggests",
      notNow: "Not now",
      customAmount: "Custom",
      addedToPlanner: "Added to Planner!",
      balance: "Current Balance",
      balancePlaceholder: "e.g. 1200.00",
      creditLimit: "Credit Limit",
      creditLimitPlaceholder: "e.g. 2000.00",
      interestRate: "Interest Rate (APR %)",
      interestRatePlaceholder: "e.g. 22.99",
      debtType: "Debt Type",
      creditCard: "Credit Card",
      loan: "Loan",
      other: "Other",
      debtDetails: "Debt Details",
      debtDetailsHint: "Optional — helps Wavey suggest the best payoff strategy",
      waveyInsight: "Wavey's Payoff Insight",
      avalanche: "Avalanche",
      avalancheDesc: "Highest APR first — saves the most in interest",
      snowball: "Snowball",
      snowballDesc: "Lowest balance first — stay motivated with quick wins",
      waveyRecommends: "Wavey recommends",
      monthlyInterest: "est. monthly interest",
      totalBalance: "total balance",
      dismissInsight: "Dismiss",
      interestPerMonth: "/mo in interest",
      askWavey: "Ask Wavey",
      waveyPlannerTitle: "Ask Wavey",
      waveyPlannerSubtitle: "Payoff advisor",
      quickAdd: "Quick add on",
      quickAddSuccess: "Added to Planner!",
      askPlaceholder: "Ask how to pay faster...",
      chipFastest: "Fastest payoff plan?",
      chipExtra25: "What if I add $25 extra?",
      chipTimeline: "When will I be debt-free?",
      chipOptimize: "Optimize my payments",
      utilizationLabel: "utilization",
      bnplDetails: "BNPL / Installment Plan",
      bnplDetailsHint: "Klarna · Affirm · Afterpay",
      totalInstallmentsLabel: "Total Payments",
      installmentsMadeLabel: "Payments Made So Far",
      incomeSource: "Income Source",
      wave: "Wave",
      bnplTracker: "BNPL Tracker",
      whichIncome: "Which income covers this?",
      whichWave: "Which wave?",
      paymentsLeftQuestion: "How many payments left?",
      addToExpensesAndPlanner: "Add to Expenses & Planner",
      bnplAdded: "Added to Expenses & Planner!",
      viewInPlanner: "View in Planner",
      paymentMade: "Payment Made",
      allPaymentsDone: "🎉 All payments done!",
      changeSelection: "change",
      payments: "payments",
      left: "left",
      paymentEach: "payment",
      bnpl: "BNPL",
      totalRemaining: "Total Remaining",
      activeItems: "Active Plans",
    },
    // WaveyAI
    waveyAI: {
      greeting: `Hey there! 👋 I'm Wavey, your AI financial coach. I can help you track expenses, analyze your spending, and give you personalized advice.

**Here's what I can do:**

💰 **Add Expenses** (Premium only)
   • "Add a $50 grocery expense to wave 2"
   • "Track my $30 Uber ride"
   • "Create a $100 electricity bill in wave 3"

📊 **Analyze Your Finances**
   • "What's my Wave 2 balance?"
   • "Show me my biggest expenses"
   • "How much did I spend on food?"

💡 **Get Financial Advice**
   • "How can I save more money?"
   • "Should I adjust my wave budgets?"
   • "Any tips to reduce my expenses?"

What would you like to do?`,
      subtitle: "Your Personal Finance Coach",
      inputPlaceholder: "Ask Wavey anything...",
      hint: 'Try asking: "What\'s my Wave 2 balance?" or "Add a $50 expense"',
    },
    // Email Verification
    emailVerification: {
      checkYourEmail: "Check Your Email",
      verificationLinkSent: "We sent a verification link to",
      clickLinkToActivate: "Click the link to activate your account.",
      didNotReceiveEmail: "Didn't receive the email?",
      resendEmail: "Resend Email",
      sending: "Sending...",
      verificationEmailSent: "Verification email sent! Check your inbox.",
      failedToResendEmail: "Failed to resend email. Please try again.",
    },
    // Dashboard hook
    dashboardHook: {
      failedToFetchData: "Failed to fetch data",
    },
    // Subscription & Pricing
    subscription: {
      title: "Simple, Transparent Pricing",
      subtitle:
        "Choose the perfect plan for your budget tracking needs. Upgrade anytime.",
      currentPlan: "Current Plan: ",
      monthly: "Monthly",
      yearly: "Yearly",
      save: "Save 16-17%",
      free: "Free",
      standard: "Standard",
      premium: "Premium",
      freeDescription: "Essential features",
      standardDescription: "Professional features",
      premiumDescription: "Advanced features",
      cancelPlan: "Cancel Plan",
      downgrade: "Downgrade",
      upgrade: "Upgrade",
      selectPlan: "Select Plan",
      getStarted: "Get Started",
      basicCharts: "Basic Charts",
      advancedCharts: "Advanced Charts",
      premiumSupport: "Premium Support",
      currentPlanLabel: "Current Plan",
      plan: "Plan:",
      billing: "Billing:",
      upgradeToPremium: "Upgrade to Premium",
      upgradeToStandard: "Upgrade to Standard",
      featuresIncluded: "What's Included",
      manageSubscription: "Manage Subscription",
      billingCycle: "Billing Cycle",
      nextBillingDate: "Next Billing Date",
      planFeatures: "Plan Features",
      unsafeContent: "Sensitive content warning",
      continueToPayment: "Continue to Payment",
      confirmUpgrade: "Confirm Upgrade",
      confirmDowngrade: "Confirm Downgrade",
      upgradeSuccess: "Upgrade successful!",
      downgradeSucess: "Downgrade successful!",
      updateSuccess: "✅ Subscription updated successfully!",
      failedBillingPortal: "Failed to open billing portal. Try again.",
      cancelAtPeriodEnd: "✅ Subscription will cancel at period end",
      failedCancelSubscription: "Failed to cancel subscription. Try again.",
      failedStartSubscription: "Failed to start subscription. Try again.",
      upgradePlan: "Upgrade Your Plan",
      viewPlans: "View Plans",
      manage: "Manage",
      details: "Subscription Details",
      unlimitedExpenses: "Unlimited Expenses",
      waveBudgeting: "Wave Budgeting",
      bankSyncing: "Bank Syncing",
      customThemes: "Custom Themes",
      aiAdvisor: "AI Advisor",
      cancelWarning:
        "Your subscription will cancel at the end of the current period",
      updatePayment: "Update Payment",
      billingHistory: "Billing History",
      noInvoices: "No invoices yet",
      mostPopular: "Most Popular",
      faq: "FAQ",
      faqCancel: "Can I cancel anytime?",
      faqCancelAnswer:
        "Yes, cancel your subscription at any time from your account settings.",
      faqRefunds: "Do you offer refunds?",
      faqRefundsAnswer: "Refunds are available within 7 days of purchase.",
      faqMonthlyYearly: "What's the difference between monthly and yearly?",
      faqMonthlyYearlyAnswer:
        "Yearly plans save you 16-17% compared to paying monthly. You'll be billed once per year.",
      backToDashboard: "← Back to Dashboard",
      cancelDialogTitle: "Cancel Subscription?",
      cancelDialogContent:
        "Your subscription will remain active until the end of your current billing period. You'll lose access to premium features after that.",
      keepSubscription: "Keep Subscription",
      yesCancel: "Yes, Cancel",
      downgradeNotAvailable: "Downgrade not yet available",
      approxMonthlyEquivalent: (monthly: number, saveText: string) =>
        `≈ $${monthly}/month (${saveText})`,
      perMonth: "/month",
      perYear: "/year",
      startFree: "Start Free",
      trialBadge: "14-day free trial • Cancel anytime",
    },
    // Onboarding
    onboarding: {
      welcome: "Welcome to WaveBudget!",
      getStarted: "Get Started",
      continueButton: "Continue →",
      backButton: "← Back",
      skipButton: "Skip",
      finishButton: "Get Started!",
      step: "Step",
      of: "of",
      setUpExpenses: "Set Up Your Expenses",
      addYourExpenses: "Add your regular expenses (rent, subscriptions, etc.)",
      trackingHelps: "Tracking helps you stay on top of your budget",
      setUpIncome: "Set Up Your Income",
      addYourIncome: "Add your income sources (salary, gig work, etc.)",
      incomeHelps: "Income helps calculate your available balance",
      exploreDashboard: "Explore Your Dashboard",
      viewCharts: "View charts, track spending, and manage your budget",
      trackOnly: "Track Only (No Payment Date)",
      frequency: "Frequency",
      trackOnlyHint: "Track this expense without a specific payment date",
      expenseName: "Expense Name",
      expenseAmount: "Amount",
      category: "Category",
      wavePaycheck: "Wave (Biweekly)",
      paycheckCategory: "Paycheck",
      otherCategory: "Other (One-time)",
      selectFrequency: "Select Frequency",
      weekly: "Weekly",
      biweekly: "Biweekly",
      monthly: "Monthly",
      oneTime: "One-time",
      incomeSource: "Income Source",
      selectIncomeSource: "-- Select --",
      addExpense: "Add Expense",
      addIncome: "Add Income",
    },
    // Export Menu
    exportMenu: {
      exportData: "Export Data",
      exportAsPDF: "Export as PDF",
      exportAsCSV: "Export as CSV",
      exportAsJSON: "Export as JSON",
      exportAsExcel: "Export as Excel",
      dataExportedPDF:
        "PDF report downloaded! Open it in browser and print to PDF.",
      dataExportedCSV: "Data exported to CSV successfully!",
      dataExportedJSON: "Data exported to JSON successfully!",
      dataExportedExcel: "Data exported to Excel successfully!",
    },
    // AI Modal
    aiModal: {
      requestsToday: "Requests today:",
      remaining: "Remaining:",
      model: "Model:",
      aiWarning: "⚠️ Only",
      aiWarningEnd: "AI requests remaining today",
      ask: "Ask me anything about optimizing your budget, paying off debt faster, or managing your expenses!",
      poweredBy: "Powered by",
      you: "You",
      currentTierLimitReached: "Tier limit reached",
      upgradeForMore: "Upgrade for more requests",
      free: "FREE",
      standard: "STANDARD",
      premium: "PREMIUM",
    },
    // Mobile Menu
    mobileMenu: {
      menu: "Menu",
      exportData: "Export Data",
      emailReport: "Email Report",
      resetAll: "Reset All",
      syncTransactions: "Sync Transactions",
      syncNow: "Sync Now",
      cancel: "Cancel",
      pushNotifications: "Push Notifications",
      bankSync: "Bank Sync",
      waveBudgetPro: "WaveBudget Pro",
      enable: "Enable",
      disable: "Disable",
      switchToDarkMode: "Switch to Dark Mode",
      switchToLightMode: "Switch to Light Mode",
      banksLinked: "Bank(s) Linked",
      syncing: "Syncing...",
      linkBankAccount: "Link Bank Account",
      bankLinkedSuccess: "✅ Bank linked successfully!",
      syncingYourTransactions: "Syncing your transactions...",
      successSynced: "Success! Synced",
      transactionsText: "transactions",
      upgradeForBankSync: "Upgrade for Bank Sync",
      transactionsSyncSuccess: "✅ Transactions synced successfully!",
      transactionsSyncFailed: "❌ Failed to sync transactions",
      syncModalDescription:
        "This will fetch your latest bank transactions and update your expenses.",
      syncModalNote: "This may take a few seconds.",
    },
    // Email Report Hook
    emailReport: {
      emailReport: "📧 Email Report",
      recipientEmail: "Recipient Email Address:",
      selectFormat: "Select Format:",
      cancel: "Cancel",
      send: "Send Email",
      noEmail: "Please enter an email address",
      invalidEmail: "Please enter a valid email address",
      reportSent: "Report sent to",
      reportSentSuccess: "successfully!",
      failedToSend: "Failed to send email",
      pdf: "PDF",
      csv: "CSV",
      json: "JSON",
      excel: "Excel",
      example: "example@email.com",
    },
    // Plaid Link Button
    plaidLink: {
      linkBankAccount: "Link Bank Account",
      failedToConnect: "Failed to connect",
      connectingBank: "Connecting to your bank...",
      selectAccount: "Select Account",
      selectAccountToLink: "Select the account you'd like to link",
      syncTransactions: "Sync Transactions",
      linkSuccess: "Bank linked successfully!",
      unlinkSuccess: "Bank unlinked successfully!",
      bankLinkedSuccess:
        "✅ Bank linked! Synced {count} transactions\nAdded {incomes} incomes and {expenses} expenses",
      bankLinkedSyncError:
        "Bank linked, but failed to sync transactions. Try syncing manually.",
      failedToLink: "Failed to link bank account. Please try again.",
      unlinkBank: "Unlink Bank",
      disconnectBank: "Disconnect Bank",
      unlinkBankConfirmTitle: "Disconnect Bank Account?",
      unlinkBankConfirmMessage:
        "This will disconnect your bank and delete all Plaid-synced expenses (autopay items). Your manually added expenses will remain. This action cannot be undone.",
      unlinkingBank: "Disconnecting...",
      failedToUnlink: "Failed to disconnect bank. Please try again.",
      // Specific error messages
      errors: {
        itemLoginRequired:
          "Your bank login has expired. Please reconnect your bank account.",
        itemLocked:
          "Your bank account is locked. Please unlock it through your bank and try again.",
        itemNotSupported:
          "This bank is no longer supported by our service. Please contact support.",
        apiError:
          "Bank service temporarily unavailable. Please try again in a few minutes.",
        rateLimitExceeded:
          "Too many requests. Please wait a few minutes before trying again.",
        syncFailed: "Failed to sync transactions. Please try again.",
        genericError:
          "An error occurred while connecting to your bank. Please try again.",
      },
      actions: {
        reconnect: "Reconnect Bank",
        retry: "Retry",
        dismiss: "Dismiss",
        contactSupport: "Contact Support",
      },
    },
    // Terms & Privacy
    termsPrivacy: {
      switchTo: "Switch to",
      spanish: "Spanish",
      english: "English",
      otherLanguage: "Spanish",
      backToHome: "Back to Home",
    },
    // Export Dialog (useExportDialog)
    exportDialog: {
      exportData: "Export Data",
      downloadDescription:
        "Download your budget data in your preferred format. Choose from PDF for reports, CSV/Excel for spreadsheets, or JSON for data integration.",
      selectExportFormat: "Select Export Format:",
      pdfReport: "PDF Report",
      pdfDescription: "Professional formatted report with charts and summaries",
      csvSpreadsheet: "CSV Spreadsheet",
      csvDescription: "Universal format compatible with Excel, Google Sheets",
      excelWorkbook: "Excel Workbook",
      excelDescription:
        "Native Excel format with multiple sheets and formatting",
      jsonData: "JSON Data",
      jsonDescription: "Raw data format for developers and data analysis",
      cancel: "Cancel",
      exporting: "Exporting...",
      download: "Download",
    },
    // Subscription
    subscriptionPage: {
      locale: "en-US",
    },
    // Help Center
    helpCenter: {
      title: "Help Center",
      subtitle: "Find answers to common questions",
      contactSupport: "Contact Support",
      email: "support@wavebudgettracker.com",
      placeholderEmail: "Your email (so we can reply)",
      placeholderMessage: "Describe your issue…",
      sendButton: "Send Message",
      sending: "Sending…",
      sent: "Message Sent!",
      sentNote: "We'll get back to you soon!",
      errorPrefix: "Error:",
      fillBothFields: "Please fill in both fields.",
      failedToSend: "Failed to send. Try again.",
      faqTitle: "Frequently Asked Questions",
      supportRequestSubject: "Support Request from Help Center",
    },
    // Onboarding Steps
    onboardingSteps: {
      validAmount: "Please enter a valid amount",
      completeSuccess: "🎉 Onboarding complete! Welcome to WaveBudget!",
      completeError: "Failed to complete onboarding. Please try again.",
      trackOnly: "Track Only (No Payment Date)",
      frequency: "Frequency",
      incomeSource: "Income Source",
      selectDash: "-- Select --",
      waveBiweekly: "Wave (Biweekly)",
      paycheck: "Paycheck",
      otherOneTime: "Other (One-time)",
      continueButton: "Continue →",
      backButton: "← Back",
      getStarted: "Get Started!",
      step1Title: "Step 1: Set Your Wave Amount",
      step1Description:
        "Your 'Wave Amount' is your take-home pay per paycheck. This is the foundation of your budget. We'll organize your expenses around your paychecks (waves).",
      enterPaycheckAmount: "Enter your paycheck amount:",
      step2Title: "Step 2: Add Your First Expense",
      step2Description:
        "Add your regular expenses like rent, utilities, subscriptions. We'll help you organize them by payment schedule.",
      step2SampleDescription:
        "Click the '+ Add New Expense' button above to add your first expense, then come back here.",
      step3Title: "Step 3: Understanding Waves",
      step3Description:
        "A 'wave' is the period between your paychecks. Instead of complicated categories, WaveBudget organizes your expenses by when you get paid.",
      saveWaveError: "Failed to save wave amount",
      validWaveAmount: "Please enter a valid wave amount",
      welcomeTitle: "🌊 Welcome to WaveBudget!",
      examplePaycheck:
        "💡 Example: If you get paid $2,500 every two weeks, enter 2500",
      howWavesWork: "🌊 How Waves Work:",
      paidBiweekly: "Paid bi-weekly? You have 2 waves per month",
      paidWeekly: "Paid weekly? You have 4 waves per month",
      assignedToWave:
        "Each expense is assigned to a wave based on its due date",
      seeAtGlance: "See at a glance how much you have left in each wave",
    },
    // Expense Form additional
    expenseForm: {
      placeholder: "e.g., Netflix",
      trackOnly: "Track Only (No Payment Date)",
      incomeSource: "Income Source",
      selectDash: "-- Select --",
      waveBiweekly: "Wave (Biweekly)",
      paycheck: "Paycheck",
      otherOneTime: "Other (One-time)",
    },
    // Landing page
    landingPage: {
      languageToggle: "Español",
      download: "Download",
      resources: "Resources",
      helpCenter: "Help Center",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
      howToInstall: "How to Install:",
      tapShareIcon: "Tap the Share icon in your browser",
      selectAddToHome: "Select 'Add to Home Screen'",
      tapAddConfirm: "Tap 'Add' to confirm",
      getNotifications: "Get app notifications & offline access!",
    },
    // Dashboard page
    dashboardPage: {
      mainIncome: "Main Income",
      totalExpenses: "Total Expenses",
      income: "Income",
      expenses: "Expenses",
      current: "Current",
      month1: "Month 1",
      month2: "Month 2",
      month3: "Month 3",
      month4: "Month 4",
      month5: "Month 5",
      month6: "Month 6",
      conservativeForecast: "Conservative (50%)",
      moderateForecast: "Moderate (70%)",
      optimisticForecast: "Optimistic (90% + 5% APY)",
      paymentConfirmation: "Payment Confirmation",
      didPaymentSucceed: "Did the payment succeed?",
      deleteExpense: "Delete Expense",
      deleteExpenseConfirmation:
        "Are you sure you want to delete this expense?",
      failedToFetchIncomes: "Failed to fetch incomes",
      noWaveExpensesToReset: "No Wave expenses to reset.",
      resetAllExpenses: "Reset All Expenses",
      resetAllExpensesConfirmation:
        "Are you sure you want to mark all expenses as unpaid?",
      resetExpensesSuccess: (count: number) => `Reset ${count} expenses!`,
      transactionsSyncedSuccess: "Transactions synced successfully!",
      failedToSyncTransactions: "Failed to sync transactions",
      offlineMessage: "You're offline. Some features may not work.",
      savingChanges: "Saving changes...",
      incomeSources: "Income Sources",
      monthlyEstimate: "Monthly Est.",
      totalIncome: "Total Income",
      netBalance: "Net Balance:",
      noExpensesYet: "No expenses yet",
      addFirstExpenseDescription:
        "Add your first expense to start tracking your budget",
      addExpense: "Add Expense",
      banksLinked: (count: number) => `${count} Bank(s) Linked`,
      confirm: "Confirm",
      cancel: "Cancel",
      mainWaveIncome: "Main Wave Income",
      yourIncomeSources: "Your Income Sources:",
      totalMonthlyIncome: "Total Monthly Income:",
      monthlyTotal: "Monthly Total",
      totalExpensesLabel: "Total Expenses:",
      manageIncomeSources: "Manage Income Sources",
      expenseListWillAppear: "Your expense list will appear here",
      enterNewAmountFor: "Enter new amount for",
      invalidAmount: "Invalid amount",
      noExpensesToDisplay: "No expenses to display",
      waveAmountUpdated: "Wave amount updated!",
      // Dashboard Stats
      totalBudget: "Total Budget",
      totalExpensesCount: "Total Wave Expenses",
      paidVsUnpaid: "Paid vs Unpaid",
      remainingBudget: "Remaining Budget",
      incomeSourcesCount: "Income Sources",
      monthlyIncomeEst: "Monthly Income Est.",
      linkedBankAccounts: "Linked Bank Accounts",
      totalBankBalance: "Total Bank Balance",
      creditCards: "credit cards",
      familyMembers: "Family Members",
      expenseDistribution: "Expense Distribution",
      paymentStatus: "Payment Status",
      incomeVsExpenses: "Income vs Expenses",
      waveBalanceDistribution: "Wave Balance Distribution",
      categoryBreakdown: "Category Breakdown",
      paymentTypeDistribution: "Payment Type Distribution",
      paidExpenses: "Paid",
      unpaidExpenses: "Unpaid",
      incomeVsSpending: "Income vs Spending",
      thisWeek: "this week",
      thisPeriod: "this period",
      thisMonth: "this month",
      fromLastMonth: "from last month",
      sources: "sources",
      accounts: "accounts",
      activeMembers: "Active members",
      editWaveAmount: "Edit Wave Amount",
      amount: "Amount",
      upgradeToStandard: "Upgrade to Standard",
      incomeSourcesPerformance: "Income Sources Performance",
      totalIncomeMonthly: "Total Income (Monthly)",
      expensesAllocated: "Expenses Allocated",
      savingsRate: "Savings Rate",
      upgradeToPremium: "Upgrade to Premium",
      remainingBalance: "Remaining Balance",
      aiSavingsForecast: "AI Savings & Investment Forecast",
      bankLinkedSuccess: "Bank linked successfully!",
      unlockAiForecasts: "Unlock AI-powered savings forecasts",
      monthlyBudgetTarget: "Monthly Budget Target",
      budgetUsageThisMonth: "Income vs Spending",
      budgetUsed: "Budget Used",
      remaining: "Remaining",
      spent: "Spent",
      otherExpenses: "Other Expenses",
      items: "items",
      count: "Count",
      balance: "Balance",
      totalBalance: "Total Balance",
      // Selective Reset Modal
      selectExpensesToDelete: "Select One-Time Expenses to Delete",
      selectExpensesDeleteHelp:
        "Recurring expenses have been reset. These one-time expenses are selected for deletion. Uncheck any you want to KEEP.",
      oneTimeExpenses: "One-Time Expenses",
      noOneTimeExpenses:
        "No one-time expenses to delete. All expenses are recurring.",
      expensesDeletedSuccess: (count: number) =>
        `${count} one-time expense(s) deleted successfully`,
    },
    successMessages: {
      expenseAdded: "Expense added successfully!",
      expenseUpdated: "Expense updated successfully!",
      expenseDeleted: "Expense deleted successfully!",
      paymentConfirmed: "Payment confirmed and expense marked as paid!",
      expensesReset: "All expenses reset to unpaid!",
      settingsUpdated: "Settings updated successfully!",
      incomeAdded: "Income added!",
      incomeUpdated: "Income updated!",
      incomeDeleted: "Income deleted!",
      bankSynced: "Bank transactions synced successfully!",
    },
    errorMessages: {
      invalidFields: "Please fill all required fields with valid values",
      invalidWave: "Please select a valid wave (1 or 2) for Wave category",
      invalidPaycheckFrequency:
        "Please select a valid payment frequency for Paycheck category",
      invalidPaycheckWave: (maxWaves: number, frequency: string) =>
        `Please select a valid wave (1-${maxWaves}) for ${frequency} Paycheck`,
      invalidPaymentUrl:
        "Please enter a valid payment URL or deep link (e.g., https://www.chase.com or chase://pay)",
      noPaymentUrl: "No payment URL provided for this expense",
      autopayManual: "Autopay expenses cannot be manually paid",
      paymentNotConfirmed: "Payment not confirmed. Expense remains unpaid.",
      fetchExpensesFailed: "Failed to fetch expenses",
      saveExpenseFailed: "Failed to save expense",
      updateExpenseFailed: "Failed to update expense",
      deleteExpenseFailed: "Failed to delete expense",
      resetExpensesFailed: "Failed to reset expenses",
      fetchSettingsFailed: "Failed to fetch settings",
      saveSettingsFailed: "Failed to save settings",
      invalidIncomeFields: "Please fill all income fields correctly",
      saveIncomeFailed: "Failed to save income",
      deleteIncomeFailed: "Failed to delete income",
      linkTokenFailed: "Failed to generate bank link token. Try again.",
      tokenExchangeFailed: "Failed to exchange bank token. Try again.",
      syncFailed: "Failed to sync transactions. Try again.",
      deleteExpensesFailed: "Failed to delete expenses",
    },
    // Email Capture Landing Page
    emailCapture: {
      tagline: "JOIN 500+ WAVE BUDGETERS",
      headline: '"Do I Have Enough for the Mortgage on the 1st?"',
      subheadline1: "Traditional budgeting apps couldn't answer this question.",
      subheadline2: "So I built something different.",
      problemTitle: "The Problem With Every Budgeting App",
      problemDesc1:
        "My wife freelances. I have a W2 salary. We have rental income, occasional consulting, and side project revenue.",
      problemDesc2: "5 different income sources",
      problemDesc3: "all hitting on different days, with different amounts.",
      ynabSays: 'YNAB: "You have $2,039 budgeted for Housing"',
      realitySays:
        "Reality: Mortgage is due tomorrow. I only have $1,200 in my account. My paycheck doesn't arrive until the 5th.",
      timingProblem:
        "The CATEGORY had money. But I didn't have it WHEN I needed it.",
      triedApps:
        "I tried YNAB. I tried Mint. I tried spreadsheets. They all organized by",
      byMonth: "MONTH",
      byCategory: "CATEGORY",
      realProblem: "But the real problem was",
      timing: "TIMING",
      waveMethodTitle: "The Wave Method",
      waveMethodDesc:
        "Instead of organizing by month or category, I organized by",
      waves: "WAVES",
      step1: "Each paycheck = a new wave",
      step2: "Bills attach to the wave that arrives before they're due",
      step3: "Visual timeline shows when money arrives and when bills are due",
      isThisForYou: "Is This For You?",
      forYouTitle: "This is for you if...",
      forYou1: "Dual-income couple (one W2, one freelance)",
      forYou2: "Side hustler with multiple income sources",
      forYou3: "Commission-based earner (base + variable)",
      forYou4: "Anyone with 2+ paychecks per month",
      forYou5: 'You\'ve asked: "Which paycheck covers this bill?"',
      notForYouTitle: "Not for you if...",
      notForYou1: "Same paycheck amount every month",
      notForYou2: "All bills are on auto-pay",
      notForYou3: "6+ months emergency fund saved",
      notForYou4: "Never worried about timing",
      stickWith: "Stick with YNAB or Mint - they'll work great for you.",
      resultsTitle: "After 12 Months Using the Wave Method",
      latePayments: "Late Payments",
      wasPerYear: "(was 2-3/year)",
      overdraftFees: "Overdraft Fees",
      partnerAlignment: "Partner Alignment",
      testimonial:
        '"We know exactly when we\'ll run short - before it happens. It just... works."',
      getGuideTitle: "Join the WaveBudget Newsletter",
      getGuideDesc:
        "Get weekly budgeting tips, money-saving strategies & product updates",
      emailPlaceholder: "Enter your email address...",
      getGuideButton: "Subscribe",
      sending: "Subscribing...",
      noSpam: "No spam. Unsubscribe anytime.",
      weeklyTips: "Weekly Tips",
      moneySaving: "Money Saving",
      productUpdates: "Updates",
      featuresTitle: "What Makes WaveBudget Different",
      featureWaveView: "Wave-Based View",
      featureWaveViewDesc: "See your cash flow as a timeline, not categories",
      featurePayments: "One-Tap Payments",
      featurePaymentsDesc:
        "Pay bills directly from the app with auto-confirmation",
      featureFamily: "Family Sharing",
      featureFamilyDesc: "Both partners see the same budget in real-time",
      featureMobile: "Mobile + Web",
      featureMobileDesc: "Works on all your devices, synced automatically",
      featureAI: "AI Financial Advisor",
      featureAIDesc: "Chat about money decisions with smart guidance",
      featureReports: "Email Reports",
      featureReportsDesc: "Monthly summaries sent to your inbox automatically",
      builtBy:
        "Built by a Principal Engineer who needed this for his own household.",
      commits: "503 commits in 2024. Used daily by my family.",
      tryFree: "Try WaveBudget Free",
      noCardRequired: "No credit card required",
      successTitle: "You're Subscribed!",
      successDesc:
        "Welcome to the WaveBudget community. Here's what you'll receive:",
      benefit1Title: "Weekly Budgeting Tips",
      benefit1Desc: "Actionable strategies to master the timing of your money",
      benefit2Title: "Money-Saving Strategies",
      benefit2Desc: "Exclusive tips from real multi-income households",
      benefit3Title: "Product Updates",
      benefit3Desc: "Be the first to know about new WaveBudget features",
    },
  },
  es: {
    title: "Rastreador de Presupuesto",
    logout: "Cerrar Sesión",
    addNewExpense: "Agregar Nuevo Gasto",
    editExpense: "Editar Gasto",
    hideForm: "Ocultar Formulario",
    expenseName: "Nombre del Gasto",
    amount: "Monto ($)",
    dueDate: "Fecha de Vencimiento",
    category: "Periodo de Pago",
    waveCategory: "Ola (Quincenal)",
    paycheckCategory: "Cheque de Pago",
    otherCategory: "Otro",
    paymentWeek: "Semana de Pago",
    paymentWave: "Ola de Pago",
    paymentFrequency: "Frecuencia de Pago",
    weekly: "Semanal (4 Semanas)",
    biweekly: "Quincenal (2 Olas)",
    monthly: "Mensual (1 Ola)",
    paymentType: "Tipo de Pago",
    web: "Web",
    app: "Aplicación",
    autopay: "Pago Automático",
    paymentUrl: "URL de Pago (opcional)",
    addExpense: "Agregar Gasto",
    updateExpense: "Actualizar Gasto",
    cancel: "Cancelar",
    expenseListSetup: "Configuración de Lista de Gastos",
    waveAmount: "Monto de Ola ($)",
    expenseList: "Lista de Gastos",
    searchExpenses: "Buscar gastos...",
    all: "Todos",
    noExpenses: "Aún no hay gastos. ¡Agrega tu primer gasto arriba!",
    expenseNameHeader: "Nombre del Gasto",
    amountHeader: "Monto",
    dueDayHeader: "Día de Vencimiento",
    categoryHeader: "Categoría",
    statusHeader: "Estado",
    payHeader: "Pagar",
    actionsHeader: "Acciones",
    paid: "Pagado",
    unpaid: "No Pagado",
    resetAllUnpaid: "Restablecer todos a no pagados",
    switchTheme: (theme: string) =>
      `Cambiar a modo ${theme === "light" ? "oscuro" : "claro"}`,
    payVia: (type: string) =>
      `Pagar vía ${type === "app" ? "aplicación" : type === "autopay" ? "pago automático" : "web"}`,
    noPaymentUrl: "No hay URL de pago disponible",
    settings: "Configuraciones",
    manageIncome: "Gestionar Ingresos",
    saveSettings: "Guardar Configuraciones",
    hideSettings: "Ocultar Configuraciones",
    language: "Idioma",
    english: "Inglés",
    spanish: "Español",
    aiAdvisor: "Wavey Asesor Financiero IA",
    aiAdvisorPlaceholder: "Pregúntame cualquier cosa sobre tu presupuesto...",
    aiAdvisorThinking: "IA está pensando...",
    aiAdvisorError: "Error al obtener respuesta de IA. Inténtalo de nuevo.",
    sendMessage: "Enviar mensaje",
    closeAdvisor: "Cerrar asesor",
    week: (num: number) => `Semana ${num}`,
    wave: (num: number) => `Ola ${num}`,
    totalUnpaidWaveExpenses: "Total de Gastos",
    totalWaves: "Total de Olas",
    otherUnpaidExpenses: "Otros Gastos No Pagados",
    expenses: (count: number) => `Gastos: $${count.toFixed(2)}`,
    balance: (amount: number) => `Saldo: $${amount.toFixed(2)}`,
    total: (amount: number, count: number) =>
      `Total: $${amount.toFixed(2)} (${count} ítems)`,
    items: "ítems",
    delete: "Eliminar",
    loading: "Cargando...",
    manageIncomeSources: "Gestionar Fuentes de Ingreso",
    hideIncomeSources: "Ocultar Fuentes de Ingreso",
    incomeName: "Nombre del Ingreso",
    incomeAmount: "Cantidad",
    incomeFrequency: "Frecuencia",
    nextPaymentDate: "Próxima Fecha de Pago (Opcional)",
    addIncome: "Agregar Ingreso",
    updateIncome: "Actualizar Ingreso",
    yourIncomeSources: "Tus Fuentes de Ingreso:",
    incomeAdded: "¡Ingreso agregado!",
    incomeUpdated: "¡Ingreso actualizado!",
    incomeDeleted: "¡Ingreso eliminado!",
    deleteIncomeConfirm: "¿Eliminar esta fuente de ingreso?",
    totalMonthlyIncome: "Ingreso Mensual Total",
    incomeTracking:
      "Rastrea múltiples fuentes de ingreso como salario, trabajo temporal, freelance, etc.",
    expenseNameTooltip:
      "Ingresa el nombre de tu factura o gasto (ej., Netflix, Renta, Pago del Auto)",
    amountTooltip: "Ingresa la cantidad exacta que pagas por este gasto",
    categoryTooltip:
      "Wave: Pagado de tu cheque regular | Paycheck: Fuentes de ingreso adicionales | Other: Gastos únicos",
    paymentUrlTooltip:
      "Ingresa el enlace del sitio web/app donde pagas esta factura. Deja en blanco si es autopago.",
    recurringExpense: "Este es un gasto recurrente",
    recurringExpenseTooltip:
      "Marca esto si el gasto se repite regularmente (ej., Netflix, renta, servicios). Puedes reiniciar todos los gastos recurrentes a la vez al comenzar un nuevo ciclo de facturación.",
    howOften: "¿Con qué frecuencia?",
    frequencyWeekly: "Semanal",
    frequencyBiweekly: "Cada 2 semanas",
    frequencyMonthly: "Mensual",
    frequencyQuarterly: "Cada 3 meses (Trimestral)",
    frequencySemiAnnual: "Cada 6 meses (Semestral)",
    frequencyAnnual: "Una vez al año (Anual)",
    recurringBadgeWeekly: "Sem",
    recurringBadgeBiweekly: "2sem",
    recurringBadgeMonthly: "Mes",
    recurringBadgeQuarterly: "3m",
    recurringBadgeSemiAnnual: "6m",
    recurringBadgeAnnual: "Anual",
    recurringBadgeWeeklyFull: "Semanal",
    recurringBadgeBiweeklyFull: "Quincenal",
    recurringBadgeMonthlyFull: "Mensual",
    recurringBadgeQuarterlyFull: "Trimestral",
    recurringBadgeSemiAnnualFull: "Cada 6 meses",
    recurringBadgeAnnualFull: "Anual",
    noRecurringExpensesToReset:
      "No hay gastos recurrentes pagados para reiniciar",
    noExpensesToReset: "No hay gastos pagados para reiniciar",
    resetRecurringExpensesConfirm: (count: number) =>
      `¿Reiniciar ${count} gastos recurrentes para un nuevo ciclo? (Los gastos únicos permanecerán igual)`,
    recurringExpensesResetSuccess: (count: number) =>
      `¡${count} gastos recurrentes reiniciados exitosamente!`,
    // Quick Add feature
    quickAdd: "Agregar Rápido",
    quickAddCommonExpenses: "Agregar Gastos Comunes Rápidamente",
    quickAddDescription:
      "Selecciona gastos populares y agrégalos instantáneamente",
    selectTemplates: "Selecciona plantillas para agregar",
    categoryStreaming: "📺 Streaming",
    categoryHousing: "🏠 Vivienda",
    categoryUtilities: "💡 Servicios Públicos",
    categoryTransportation: "🚗 Transporte",
    categorySubscriptions: "📱 Suscripciones",
    categoryInsurance: "🛡️ Seguros",
    categoryFood: "🍔 Comida",
    reviewAndCustomize: "Revisar y Personalizar",
    backToTemplates: "Volver a Plantillas",
    addSelected: (count: number) => `Agregar Seleccionados (${count})`,
    reviewSelected: "Revisar Seleccionados",
    templatesSelected: (count: number) =>
      `${count} ${count === 1 ? "plantilla" : "plantillas"} seleccionadas`,
    editDetails: "Editar",
    removeTemplate: "Eliminar",
    amountRequired: "Cantidad requerida",
    enterAmount: "Ingresar cantidad",
    templateAddedSuccess: (count: number) =>
      `¡${count} ${count === 1 ? "gasto agregado" : "gastos agregados"} exitosamente!`,
    noTemplatesSelected:
      "No hay plantillas seleccionadas. Por favor selecciona al menos una plantilla.",
    missingRequiredFields: (count: number) =>
      `${count} ${count === 1 ? "plantilla necesita" : "plantillas necesitan"} cantidad`,
    fillRequiredFields: "Completar Campos Requeridos",
    allTemplatesAdded:
      "¡Todos los gastos comunes han sido agregados! Puedes agregar gastos personalizados usando el formulario regular.",
    // Visualización de Datos
    dataVisualization: "Visualización de Datos",
    expenseBreakdown: "Desglose de Gastos",
    waveBalances: "Saldos por Ola",
    spendingTrends: "Tendencias de Gastos (30 Días)",
    topExpenses: "5 Gastos Principales",
    incomeVsExpenses: "Ingresos vs Gastos",
    spendingPatterns: "Patrones de Gasto",
    balanceForecast: "Proyección de Saldo (3 Meses)",
    upgradeForCharts: "Mejora tu plan para desbloquear análisis avanzados",
    premiumFeature: "Función Premium",
    standardFeature: "Función Estándar",
    waveText: "Ola",
    other: "Otro",
    balanceText: "Saldo",
    income: "Ingresos",
    expensesText: "Gastos",
    temporalCategory: "Temporal (Pagos Quincenales)",
    bankLinking: "Enlace Bancario",
    linkBankAccount: "Enlazar Cuenta Bancaria",
    premiumRequiredForBankLink:
      "Suscripción premium requerida para enlazar cuentas bancarias",
    // Settings page
    settingsPage: {
      totalWaveAmount: "Cantidad Total de Wave",
      sumOfAllWaves: "Esta es la suma de todas tus cantidades de wave abajo",
      week1Amount: "Cantidad Semana 1",
      week2Amount: "Cantidad Semana 2",
      week3Amount: "Cantidad Semana 3",
      week4Amount: "Cantidad Semana 4",
      wave1Amount: "Cantidad Wave 1",
      wave2Amount: "Cantidad Wave 2",
      totalMonthlyIncome: "Ingreso Mensual Total",
      mainIncome: "Ingreso Principal",
      additionalSources: "Fuentes Adicionales",
      allIncomeSources: "Todas las Fuentes de Ingreso",
      waveIncome: "Ingreso Wave",
      paycheck: "Nómina",
      mainIncomeLabel: "Ingreso Principal",
      primary: "PRINCIPAL",
      mainIncomeColor: "Color del ingreso principal",
      save: "Guardar",
      hideAdditionalSources: "Ocultar Fuentes Adicionales",
      addAdditionalSources: "Agregar Fuentes Adicionales",
      extraIncomeHint:
        "Agrega fuentes de ingreso adicionales como trabajo temporal, freelance, bonos, etc.",
      incomeLimit: (current: number, max: number | string) =>
        `${current} / ${max}`,
      freeIncomeLimit: "Gratis: Solo ingreso principal",
      standardIncomeLimit: "Standard: Principal + 2 fuentes",
      premiumIncomeLimit: "Premium: Fuentes ilimitadas",
      incomeName: "Nombre del Ingreso",
      incomeNamePlaceholder: "ej., Uber, Freelance",
      amount: "Cantidad",
      frequency: "Frecuencia",
      weekly: "Semanal",
      biweekly: "Quincenal",
      monthly: "Mensual",
      oneTime: "Único",
      nextPaymentOptional: "Próximo Pago (Opcional)",
      color: "Color",
      addIncome: "Agregar Ingreso",
      appPreferences: "Preferencias de la App",
      hideThemeColors: "Ocultar Colores del Tema",
      customizeThemeColors: "Personalizar Colores del Tema",
      themeColorsHint:
        "Elige entre presets gratis o crea colores personalizados con Premium",
      themePresetFree: "Preset de Tema (Gratis)",
      blue: "Azul",
      green: "Verde",
      purple: "Morado",
      customColorsPremium: "Colores Personalizados (Premium)",
      premiumOnly: "Solo Premium",
      primaryColor: "Color Principal",
      primaryDark: "Principal Oscuro",
      applyCustomColors: "Aplicar Colores Personalizados",
      upgradePremiumCustomColors:
        "¡Actualiza a Premium para desbloquear colores personalizados!",
      saveThemeColors: "Guardar Colores del Tema",
      currentPlan: "Plan Actual",
      upgradeUnlockColors: "Actualiza para desbloquear colores personalizados",
      upgradeNow: "Actualizar Ahora",
      profileDetails: "Detalles del Perfil",
      firstName: "Nombre",
      lastName: "Apellido",
      emailAddress: "Correo Electrónico",
      profileImage: "Imagen de Perfil",
      chooseImage: "Elegir Imagen",
      currentImage: "Imagen actual",
      maxSizeSupported: "Tamaño máx: 5MB. Formatos: JPG, PNG, GIF",
      profileImageUploaded: "Imagen de perfil cargada",
      noImageUploaded: "Sin imagen cargada",
      saveChanges: "Guardar Cambios",
      changePassword: "Cambiar Contraseña",
      currentPassword: "Contraseña Actual",
      newPassword: "Nueva Contraseña",
      confirmNewPassword: "Confirmar Nueva Contraseña",
      passwordMinLength: "Debe tener al menos 8 caracteres",
      updatePassword: "Actualizar Contraseña",
      clickLockToChangePassword:
        "Haz clic en el icono del candado para cambiar tu contraseña",
      familySharing: "Compartir en Familia",
      shareBudgetFamily:
        "Comparte tu presupuesto con hasta 3 miembros de la familia",
      deleteIncome: "Eliminar Ingreso",
      deleteIncomeConfirmation:
        "¿Estás seguro de que quieres eliminar esta fuente de ingreso?",
      confirm: "Confirmar",
      upgradeRequired: "Actualización Requerida",
      familyMember: "Miembro de Familia",
      youArePartOf: "Eres parte de",
      leaveFamilyButton: "Salir de Familia",
      familyMembers: "Miembros de Familia",
      inviteFamilyMember: "Invitar Miembro de Familia",
      memberEmailAddress: "Correo Electrónico",
      partnerExample: "pareja@ejemplo.com",
      sendInvite: "Enviar Invitación",
      active: "Activo",
      pending: "Pendiente",
      removeFamilyMember: "¿Eliminar este miembro?",
      memberRemoved: "Miembro eliminado",
      failedToRemoveMember: "Error al eliminar miembro",
      leftFamilyAccount: "Saliste de la cuenta familiar",
      failedToLeaveFamily: "Error al salir de la familia",
      removeFamilyConfirm: "¿Eliminar este miembro?",
      leaveFamilyConfirm: "¿Salir de esta cuenta familiar?",
      invitationSent: "¡Invitación enviada!",
      failedToSendInvitation: "Error al enviar invitación",
      members: "Miembros",
      youCanAddMore: (count: number) =>
        `Puedes agregar ${count} miembro${count > 1 ? "s" : ""} más`,
      maximumMembersReached: "Máximo de miembros alcanzado",
      membersCount: (current: number, max: number) =>
        `${current} / ${max} Miembros`,
      upgradeAddMoreSources: "¿Actualizar para agregar más fuentes?",
      customThemeRequiresPremium:
        "Los colores personalizados requieren suscripción Premium",
      customColorsRequirePremium:
        "Los colores personalizados requieren Premium. ¡Actualiza ahora!",
      themeColorsSaved: "¡Colores guardados!",
      limitReachedFree: "Límite alcanzado! Standard agrega 2 fuentes",
      limitReachedStandard: "Límite alcanzado! Premium = ilimitadas",
      enterFirstName: "Ingrese su nombre",
      enterLastName: "Ingrese su apellido",
      enterEmail: "Ingrese su correo",
      imageLessThan5MB: "La imagen debe ser menor a 5MB",
      pleaseSelectImage: "Por favor selecciona un archivo de imagen",
      failedReadImage: "Error al leer el archivo de imagen",
      profileUpdatedSuccess: "¡Perfil actualizado exitosamente!",
      failedUpdateProfile: "Error al actualizar el perfil",
      passwordsDoNotMatch: "Las contraseñas no coinciden",
      passwordMinLengthError: "La contraseña debe tener al menos 8 caracteres",
      passwordUpdatedSuccess: "¡Contraseña actualizada exitosamente!",
      failedUpdatePassword: "Error al actualizar la contraseña",
      // Email notifications
      emailNotifications: "Notificaciones por Correo",
      emailNotificationsInfo:
        "Las notificaciones por correo se enviarán a tu dirección de correo electrónico registrada",
      expenseReminders: "Recordatorios de Gastos",
      expenseRemindersDesc: "Recibe notificaciones cuando vencen las facturas",
      notificationsSaved: "Notificaciones guardadas",
      paymentAlerts: "Alertas de Pago",
      paymentAlertsDesc: "Notificaciones cuando se realizan pagos",
      budgetAlerts: "Alertas de Presupuesto",
      budgetAlertsDesc:
        "Alerta cuando te acercas a los límites del presupuesto",
      weeklySummary: "Resumen Semanal",
      weeklySummaryDesc: "Recibe resúmenes semanales del presupuesto",
      familyActivity: "Actividad Familiar",
      familyActivityDesc: "Notificaciones de acciones de miembros familiares",
      saveNotifications: "Guardar Notificaciones",
      failedToSaveNotifications: "Error al guardar las notificaciones",
      free: "GRATIS",
      standard: "ESTÁNDAR",
      premium: "PREMIUM",
      // Cookie Preferences
      cookiePreferences: "Preferencias de Cookies",
      cookiePreferencesDesc:
        "Gestiona tus preferencias de cookies. Algunas cookies son esenciales para que el sitio web funcione, mientras que otras nos ayudan a mejorar tu experiencia.",
      functionalCookies: "Cookies Funcionales",
      functionalCookiesDesc:
        "Esenciales para la autenticación, gestión de sesiones y funcionalidad básica del sitio.",
      analyticsCookies: "Cookies de Análisis",
      analyticsCookiesDesc:
        "Nos ayudan a entender cómo usas el sitio y mejorar tu experiencia a través de Google Analytics.",
      marketingCookies: "Cookies de Marketing",
      marketingCookiesDesc:
        "Se utilizan para mostrarte anuncios y contenido relevante. Opcionales y se pueden desactivar en cualquier momento.",
      requiredBadge: "Requerido",
      cannotBeDisabled: "Estas cookies no se pueden desactivar",
      howToReset: "Cómo restablecer:",
      resetInstructions:
        "Borra las cookies y localStorage de tu navegador para ver el banner de consentimiento de cookies nuevamente. Luego puedes actualizar tus preferencias.",
      viewCookiePolicy: "Ver nuestra Política de Cookies",
      replayOnboarding: "Repetir tour de Introducción",
      takeATour: "Ir al tour de Introducción",
    },
    // Cookie Policy page
    cookiePolicy: {
      title: "Política de Cookies",
      lastUpdated: "Última Actualización",
      backToSettings: "Volver a Configuración",
      whatAreCookies: "¿Qué son las Cookies?",
      whatAreCookiesDesc:
        "Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo (computadora, tableta o teléfono móvil) cuando visitas un sitio web. Ayudan a los sitios web a reconocerte, recordar tus preferencias y brindarte una mejor experiencia.",
      howWeUseCookies: "Cómo Usamos las Cookies",
      howWeUseCookiesDesc:
        "Budget Tracker utiliza cookies para varios propósitos esenciales y beneficiosos:",
      functionalCookiesTitle: "Cookies Funcionales (Requeridas)",
      functionalCookiesIntro:
        "Estas cookies son esenciales para que el sitio web funcione correctamente. Se utilizan para:",
      functionalList1: "Mantenerte conectado a tu cuenta",
      functionalList2: "Recordar tus preferencias y configuraciones",
      functionalList3: "Mantener tu sesión",
      functionalList4: "Habilitar comunicación segura",
      functionalList5: "Prevenir fraude y abuso",
      functionalRequired: "Estas cookies no se pueden desactivar",
      functionalRequiredDesc:
        "ya que son necesarias para que el sitio funcione. Puedes controlarlas a través de la configuración de tu navegador, pero esto puede afectar tu capacidad para usar el sitio.",
      analyticsCookiesTitle: "Cookies de Análisis (Opcionales)",
      analyticsCookiesIntro:
        "Utilizamos Google Analytics para entender cómo usas nuestro sitio web. Estas cookies recopilan:",
      analyticsList1: "Páginas que visitas",
      analyticsList2: "Tiempo pasado en las páginas",
      analyticsList3: "Patrones de comportamiento del usuario",
      analyticsList4: "Métricas de rendimiento",
      analyticsList5: "Información del dispositivo y navegador",
      analyticsNoPersonalData:
        "No se recopilan datos personales a través de cookies de análisis.",
      analyticsAnonymized:
        "Todos los datos son anonimizados y se utilizan solo para mejorar nuestros servicios. Puedes optar por no usar cookies de análisis en cualquier momento en tus preferencias de cookies o a través de la extensión de navegador de exclusión de Google Analytics.",
      marketingCookiesTitle: "Cookies de Marketing (Opcionales)",
      marketingCookiesIntro:
        "Estas cookies nos ayudan a mostrarte contenido y anuncios relevantes basados en tus intereses. Pueden ser utilizadas por:",
      marketingList1: "Socios publicitarios",
      marketingList2: "Plataformas de redes sociales",
      marketingList3: "Servicios de retargeting",
      marketingNoPersonalData:
        "No se comparten datos personales con anunciantes.",
      marketingOptOut:
        "Puedes desactivar estas cookies en cualquier momento en tus preferencias de cookies.",
      thirdPartyCookies: "Cookies de Terceros",
      thirdPartyCookiesDesc:
        "Podemos usar cookies de servicios de terceros confiables para mejorar tu experiencia:",
      googleAnalyticsDesc: "Nos ayuda a entender los patrones de uso del sitio",
      sentryDesc: "Monitorea el rendimiento y errores de la aplicación",
      stripeDesc: "Procesa pagos seguros (si corresponde)",
      otherPartners: "Otros Socios",
      otherPartnersDesc: "Puede incluir socios publicitarios y de análisis",
      thirdPartyPrivacy:
        "Estos socios tienen sus propias políticas de privacidad y pueden usar cookies para rastrearte en sitios web.",
      cookieRetention: "Retención de Cookies",
      cookieRetentionDesc:
        "Las cookies se retienen durante diferentes períodos según su propósito:",
      sessionCookies: "Cookies de Sesión",
      sessionCookiesDesc: "Se eliminan cuando cierras tu navegador",
      persistentCookies: "Cookies Persistentes",
      persistentCookiesDesc: "Permanecen hasta 2 años o hasta que las elimines",
      analyticsCookiesRetention: "Cookies de Análisis",
      analyticsCookiesRetentionDesc:
        "Se retienen para análisis y se eliminan dentro de 26 meses",
      howToControl: "Cómo Controlar las Cookies",
      usingCookieSettings:
        "Usando la Configuración de Cookies de Budget Tracker",
      usingCookieSettingsDesc:
        "Puedes controlar tus preferencias de cookies en cualquier momento:",
      controlStep1: "Yendo a Configuración → Preferencias de Cookies",
      controlStep2:
        "Activando o desactivando las cookies de análisis y marketing",
      controlStep3: 'Haciendo clic en "Guardar Preferencias"',
      usingBrowser: "Usando tu Navegador",
      usingBrowserDesc:
        "También puedes controlar las cookies a través de la configuración de tu navegador:",
      chromeInstructions:
        "Configuración → Privacidad y seguridad → Cookies y otros datos del sitio",
      firefoxInstructions:
        "Preferencias → Privacidad y Seguridad → Cookies y Datos del Sitio",
      safariInstructions:
        "Preferencias → Privacidad → Cookies y datos del sitio web",
      edgeInstructions:
        "Configuración → Privacidad, búsqueda y servicios → Cookies y otros datos del sitio",
      note: "Nota",
      disablingFunctional:
        "Desactivar las cookies funcionales puede impedir que el sitio funcione correctamente.",
      optOutAnalytics: "Optar por No Recibir Análisis",
      optOutAnalyticsDesc:
        "Para optar por no recibir el seguimiento de Google Analytics, puedes:",
      optOutOption1:
        "Usar la extensión de navegador de exclusión de Google Analytics",
      optOutOption2:
        "Desactivar las cookies de análisis en nuestras preferencias de cookies",
      optOutOption3:
        'Habilitar "No Rastrear" en la configuración de tu navegador',
      privacyRights: "Tus Derechos de Privacidad",
      privacyRightsDesc:
        "Bajo GDPR, CCPA, PIPEDA y otras leyes de privacidad, tienes derecho a:",
      rightAccess: "Acceso",
      rightAccessDesc: "Saber qué cookies usamos",
      rightConsent: "Consentimiento",
      rightConsentDesc: "Elegir qué cookies aceptar",
      rightWithdraw: "Retirar",
      rightWithdrawDesc: "Retirar el consentimiento en cualquier momento",
      rightDelete: "Eliminar",
      rightDeleteDesc: "Solicitar la eliminación de tus datos",
      rightPortability: "Portabilidad",
      rightPortabilityDesc: "Exportar tus datos en un formato portable",
      exerciseRights:
        "Para ejercer cualquiera de estos derechos, contáctanos en",
      changesToPolicy: "Cambios a Esta Política",
      changesToPolicyDesc:
        'Podemos actualizar esta Política de Cookies de vez en cuando para reflejar cambios en la tecnología, las leyes o nuestras prácticas. Te notificaremos de cambios importantes publicando la política actualizada en nuestro sitio web y actualizando la fecha de "Última Actualización" arriba.',
      contactUs: "Contáctanos",
      contactUsDesc:
        "Si tienes preguntas sobre nuestro uso de cookies o esta política, contáctanos en:",
      email: "Correo Electrónico",
      website: "Sitio Web",
      compliance: "Cumplimiento y Estándares",
      complianceDesc: "Nuestras prácticas de cookies cumplen con:",
      gdpr: "Reglamento General de Protección de Datos (GDPR) - UE",
      ccpa: "Ley de Privacidad del Consumidor de California (CCPA) - EE.UU.",
      pipeda:
        "Ley de Protección de Información Personal y Documentos Electrónicos (PIPEDA) - Canadá",
      ePrivacy:
        "Directiva de Privacidad Electrónica - Estados Miembros de la UE",
      canSpam: "Ley CAN-SPAM - EE.UU.",
    },
    // Dashboard page
    dashboardPage: {
      mainIncome: "Ingreso Principal",
      totalExpenses: "Gastos Totales",
      income: "Ingreso",
      expenses: "Gastos",
      current: "Actual",
      month1: "Mes 1",
      month2: "Mes 2",
      month3: "Mes 3",
      month4: "Mes 4",
      month5: "Mes 5",
      month6: "Mes 6",
      conservativeForecast: "Conservador (50%)",
      moderateForecast: "Moderado (70%)",
      optimisticForecast: "Optimista (90% + 5% APY)",
      paymentConfirmation: "Confirmar Pago",
      didPaymentSucceed: "¿El pago fue exitoso?",
      deleteExpense: "Eliminar Gasto",
      deleteExpenseConfirmation:
        "¿Estás seguro de que quieres eliminar este gasto?",
      failedToFetchIncomes: "Error al cargar ingresos",
      noWaveExpensesToReset: "No hay gastos de Wave para resetear.",
      resetAllExpenses: "Restablecer Todos",
      resetAllExpensesConfirmation:
        "¿Estás seguro de que quieres marcar todos los gastos como no pagados?",
      resetExpensesSuccess: (count: number) =>
        `¡Reset exitoso de ${count} gastos!`,
      transactionsSyncedSuccess: "¡Transacciones sincronizadas exitosamente!",
      failedToSyncTransactions: "Error al sincronizar transacciones",
      offlineMessage:
        "Estás sin conexión. Algunas funciones pueden no funcionar.",
      savingChanges: "Guardando cambios...",
      incomeSources: "Fuentes de Ingreso",
      monthlyEstimate: "Est. Mensual",
      totalIncome: "Ingreso Total",
      netBalance: "Balance Neto:",
      noExpensesYet: "Sin gastos aún",
      addFirstExpenseDescription:
        "Agrega tu primer gasto para comenzar a rastrear tu presupuesto",
      addExpense: "Agregar Gasto",
      banksLinked: (count: number) => `${count} Banco(s) Vinculado(s)`,
      confirm: "Confirmar",
      cancel: "Cancelar",
      mainWaveIncome: "Ingreso Wave Principal",
      yourIncomeSources: "Tus Fuentes de Ingreso:",
      totalMonthlyIncome: "Ingreso Mensual Total:",
      monthlyTotal: "Total Mensual",
      totalExpensesLabel: "Gastos Totales:",
      manageIncomeSources: "Gestionar Fuentes de Ingreso",
      expenseListWillAppear: "Tu lista de gastos aparecerá aquí",
      enterNewAmountFor: "Ingresa el nuevo monto para",
      invalidAmount: "Monto inválido",
      noExpensesToDisplay: "Sin gastos que mostrar",
      waveAmountUpdated: "¡Monto de wave actualizado!",
      // Dashboard Stats
      totalBudget: "Presupuesto Total",
      totalExpensesCount: "Total Olas de Gastos",
      paidVsUnpaid: "Pagados vs Pendientes",
      remainingBudget: "Presupuesto Restante",
      incomeSourcesCount: "Fuentes de Ingreso",
      monthlyIncomeEst: "Est. Ingreso Mensual",
      linkedBankAccounts: "Cuentas Bancarias Enlazadas",
      totalBankBalance: "Saldo Bancario Total",
      creditCards: "tarjetas de crédito",
      familyMembers: "Miembros Familiares",
      expenseDistribution: "Distribución de Gastos",
      paymentStatus: "Estado de Pagos",
      incomeVsExpenses: "Ingresos vs Gastos",
      waveBalanceDistribution: "Distribución de Saldo por Wave",
      categoryBreakdown: "Desglose por Categoría",
      paymentTypeDistribution: "Distribución por Tipo de Pago",
      paidExpenses: "Pagados",
      unpaidExpenses: "Pendientes",
      incomeVsSpending: "Ingresos vs Gastos",
      thisWeek: "esta semana",
      thisPeriod: "este período",
      thisMonth: "este mes",
      fromLastMonth: "desde el mes pasado",
      sources: "fuentes",
      accounts: "cuentas",
      activeMembers: "Miembros activos",
      editWaveAmount: "Editar Monto de Wave",
      amount: "Cantidad",
      upgradeToStandard: "Actualizar a Estándar",
      incomeSourcesPerformance: "Rendimiento de Fuentes de Ingreso",
      totalIncomeMonthly: "Ingreso Total (Mensual)",
      expensesAllocated: "Gastos Asignados",
      savingsRate: "Tasa de Ahorro",
      upgradeToPremium: "Actualizar a Premium",
      remainingBalance: "Balance Restante",
      aiSavingsForecast: "Pronóstico IA de Ahorros e Inversión",
      bankLinkedSuccess: "¡Banco vinculado exitosamente!",
      unlockAiForecasts: "Desbloquea pronósticos de ahorro con IA",
      monthlyBudgetTarget: "Objetivo de Presupuesto Mensual",
      budgetUsageThisMonth: "Ingresos vs Gastos",
      budgetUsed: "Presupuesto Usado",
      remaining: "Restante",
      spent: "Gastado",
      otherExpenses: "Otros Gastos",
      items: "items",
      count: "Cantidad",
      balance: "Saldo",
      totalBalance: "Balance Total",
      // Selective Reset Modal
      selectExpensesToDelete: "Seleccionar Gastos Únicos para Eliminar",
      selectExpensesDeleteHelp:
        "Los gastos recurrentes han sido restablecidos. Estos gastos únicos están seleccionados para eliminación. Desmarca los que quieras MANTENER.",
      oneTimeExpenses: "Gastos Únicos",
      noOneTimeExpenses:
        "No hay gastos únicos para eliminar. Todos los gastos son recurrentes.",
      expensesDeletedSuccess: (count: number) =>
        `${count} gasto(s) único(s) eliminado(s) exitosamente`,
    },
    // Auth page
    authPage: {
      accountCreatedSuccess:
        "¡Cuenta creada! Por favor revisa tu correo para verificar tu cuenta.",
      welcomeBack: "Bienvenido de Nuevo",
      createAccount: "Crear Cuenta",
      signInToContinue: "Inicia sesión para continuar",
      signUpToGetStarted: "Regístrate para comenzar",
      firstName: "Nombre",
      lastName: "Apellido",
      emailAddress: "Dirección de Email",
      password: "Contraseña",
      reenterPassword: "Vuelve a ingresar la contraseña",
      signIn: "Iniciar Sesión",
      or: "o",
      authenticating: "Autenticando...",
      signInWithBiometric: "Iniciar sesión con Face ID / Touch ID",
      needAccount: "¿Necesitas una cuenta? Regístrate",
      alreadyHaveAccount: "¿Ya tienes cuenta? Inicia Sesión",
      forgotPassword: "¿Olvidaste tu contraseña?",
      hidePassword: "Ocultar contraseña",
      showPassword: "Mostrar contraseña",
      pleaseEnterEmail: "Por favor ingresa tu dirección de email primero",
      resetLinkSent: "¡Enlace de restablecimiento enviado a tu email!",
      failedToSendResetLink: "Error al enviar enlace de restablecimiento",
      enterVerificationCode: "Ingresa el código de verificación",
      mfaCodeLabel: "Código",
      verifyCode: "Verificar",
      cancelBtn: "Cancelar",
      resendCodeBtn: "Reenviar código",
      rememberDevice: "Recordar este dispositivo por 30 días",
      signInWithGoogle: "Iniciar sesión con Google",
      resetPasswordBtn: "Restablecer contraseña",
    },
    // Editable wave amount
    editableWave: {
      invalidAmount: "Cantidad inválida",
      failedToSave: "Error al guardar",
    },
    // Landing page
    landingPage: {
      languageToggle: "English",
      download: "Descargar",
      resources: "Recursos",
      helpCenter: "Centro de Ayuda",
      privacyPolicy: "Política de Privacidad",
      termsOfService: "Términos de Servicio",
      howToInstall: "Cómo Instalar:",
      tapShareIcon: "Toca el ícono de Compartir en tu navegador",
      selectAddToHome: "Selecciona 'Agregar a Pantalla de Inicio'",
      tapAddConfirm: "Toca 'Agregar' para confirmar",
      getNotifications:
        "¡Obtén notificaciones de la app y acceso sin conexión!",
    },
    // Navbar
    navbar: {
      dashboard: "Panel",
      expenses: "Gastos",
      settings: "Ajustes",
      subscription: "Suscripción",
      reset: "Restablecer",
      resetTooltip:
        "Restablecer todos los gastos a no pagados para comenzar nuevo ciclo de facturación",
      export: "Exportar",
      email: "Correo",
      banks: "Banco(s)",
      syncing: "Sincronizando...",
      sync: "Sincronizar",
      linkBank: "Vincular",
      waveyAI: "IA Asesor",
      planner: "Planificador",
      notifications: "Notificaciones",
      theme: "Tema",
      language: "Idioma",
      logout: "Cerrar Sesión",
    },
    sidebar: {
      navigation: "Navegación",
      tools: "Herramientas",
      actions: "Acciones",
      reports: "Reportes",
      reimbursements: "Reembolsos",
      notes: "Notas",
    },
    notesPage: {
      title: "Notas",
      subtitle: "Lleva un registro de notas mensuales sobre tu presupuesto",
      addNote: "Agregar una nota",
      addButton: "Agregar",
      placeholder: "ej. Gasté $90 de más en la ola 1",
      previousMonth: "Mes anterior",
      nextMonth: "Mes siguiente",
      emptyState: "No hay notas este mes. Agrega una arriba.",
      added: "Nota agregada",
      addFailed: "Error al agregar la nota",
      updated: "Nota actualizada",
      updateFailed: "Error al actualizar la nota",
      deleted: "Nota eliminada",
      deleteFailed: "Error al eliminar la nota",
      deleteTitle: "¿Eliminar nota?",
      deleteConfirm: "Esta nota se eliminará permanentemente.",
      cancel: "Cancelar",
      save: "Guardar",
      edit: "Editar",
      delete: "Eliminar",
    },
    reimbursementsPage: {
      title: "Reembolsos",
      subtitle: "Rastrea los gastos de tarjeta de crédito que te deben",
      markReimbursable: "Marcar para reembolso",
      unmark: "Desmarcar",
      whoOwes: "¿Quién te debe?",
      deadline: "Fecha límite",
      statusPending: "Pendiente",
      statusSubmitted: "Enviado",
      statusReceived: "Recibido",
      downloadPdf: "Descargar PDF",
      exportEmail: "Exportar por correo",
      exportSent: "¡Correo enviado!",
      exportError: "Error al enviar el correo",
      totalOutstanding: "Total pendiente",
      totalReceived: "Total recibido",
      items: "Elementos",
      filterAll: "Todas las transacciones",
      filterPending: "Por cobrar",
      filterReceived: "Recibidos",
      emptyNoCreditCard: "Sin transacciones de tarjeta de crédito",
      emptyNoCreditCardSub: "Vincula una cuenta bancaria con tarjeta de crédito para rastrear reembolsos",
      emptyFiltered: "No hay reembolsos en esta categoría",
      editDetails: "Editar detalles",
      saveDetails: "Guardar",
      cancel: "Cancelar",
      selectToExport: "Selecciona elementos para exportar",
      noneSelected: "Selecciona al menos un elemento",
      failedToUpdate: "Error al actualizar",
      failedToSave: "Error al guardar",
    },
    planner: {
      title: "Planificador",
      subtitle: "Rastrea tus metas financieras y planes de pago",
      addItem: "Agregar Plan",
      editItem: "Editar Plan",
      noItems: "Sin planes aún",
      noItemsSubtitle: "Agrega tu primera meta financiera o plan de pago",
      itemTitle: "Título",
      itemTitlePlaceholder: "ej. Pagar extra en Chase Freedom",
      amount: "Monto",
      targetDate: "Fecha Objetivo",
      targetDatePlaceholder: "ej. 05/2025",
      type: "Tipo",
      status: "Estado",
      notes: "Notas",
      notesPlaceholder: "Notas opcionales...",
      payExtra: "Pago Extra",
      save: "Ahorrar",
      transfer: "Transferir",
      milestone: "Meta",
      pending: "Pendiente",
      inProgress: "En Progreso",
      completed: "Completado",
      skipped: "Omitido",
      all: "Todo",
      deleteConfirm: "¿Eliminar este plan?",
      deleteSuccess: "Plan eliminado",
      saveSuccess: "Plan guardado",
      markDone: "Marcar como Hecho",
      waveyTip: "Parece que estás pagando el mínimo en",
      waveyTipSuffix: "— pagar un poco más libera crédito más rápido.",
      addToPlannerCta: "Agregar al Planificador",
      waveySuggests: "Wavey sugiere",
      notNow: "Ahora no",
      customAmount: "Personalizado",
      addedToPlanner: "¡Agregado al Planificador!",
      balance: "Balance Actual",
      balancePlaceholder: "ej. 1200.00",
      creditLimit: "Límite de Crédito",
      creditLimitPlaceholder: "ej. 2000.00",
      interestRate: "Tasa de Interés (APR %)",
      interestRatePlaceholder: "ej. 22.99",
      debtType: "Tipo de Deuda",
      creditCard: "Tarjeta de Crédito",
      loan: "Préstamo",
      other: "Otro",
      debtDetails: "Detalles de Deuda",
      debtDetailsHint: "Opcional — ayuda a Wavey a sugerir la mejor estrategia de pago",
      waveyInsight: "Estrategia de Pago de Wavey",
      avalanche: "Avalancha",
      avalancheDesc: "Primero el APR más alto — ahorra más en intereses",
      snowball: "Bola de Nieve",
      snowballDesc: "Primero el balance más bajo — mantén motivación con victorias rápidas",
      waveyRecommends: "Wavey recomienda",
      monthlyInterest: "int. mensual estimado",
      totalBalance: "balance total",
      dismissInsight: "Descartar",
      interestPerMonth: "/mes en intereses",
      askWavey: "Pregunta a Wavey",
      waveyPlannerTitle: "Pregunta a Wavey",
      waveyPlannerSubtitle: "Asesor de pagos",
      quickAdd: "Agregar extra en",
      quickAddSuccess: "¡Agregado al Planificador!",
      askPlaceholder: "Pregunta cómo pagar más rápido...",
      chipFastest: "¿Plan de pago más rápido?",
      chipExtra25: "¿Y si agrego $25 extra?",
      chipTimeline: "¿Cuándo estaré libre de deudas?",
      chipOptimize: "Optimizar mis pagos",
      utilizationLabel: "utilización",
      bnplDetails: "Plan BNPL / Cuotas",
      bnplDetailsHint: "Klarna · Affirm · Afterpay",
      totalInstallmentsLabel: "Total de Pagos",
      installmentsMadeLabel: "Pagos Realizados",
      incomeSource: "Fuente de Ingreso",
      wave: "Ola",
      bnplTracker: "Rastreador BNPL",
      whichIncome: "¿Qué ingreso cubre esto?",
      whichWave: "¿En qué ola?",
      paymentsLeftQuestion: "¿Cuántos pagos quedan?",
      addToExpensesAndPlanner: "Agregar a Gastos y Planificador",
      bnplAdded: "¡Agregado a Gastos y Planificador!",
      viewInPlanner: "Ver en Planificador",
      paymentMade: "Pago Registrado",
      allPaymentsDone: "🎉 ¡Todos los pagos completados!",
      changeSelection: "cambiar",
      payments: "pagos",
      left: "restantes",
      paymentEach: "pago",
      bnpl: "BNPL",
      totalRemaining: "Total Restante",
      activeItems: "Planes Activos",
    },
    // WaveyAI
    waveyAI: {
      greeting: `¡Hola! 👋 Soy Wavey, tu coach financiero con IA. Puedo ayudarte a rastrear gastos, analizar tus hábitos de gasto y darte consejos personalizados.

**Esto es lo que puedo hacer:**

💰 **Agregar Gastos** (Solo Premium)
   • "Agrega un gasto de $50 en comida para wave 2"
   • "Registra mi viaje de $30 en Uber"
   • "Crea una factura de luz de $100 en wave 3"

📊 **Analizar tus Finanzas**
   • "¿Cuál es mi balance de Wave 2?"
   • "Muestra mis gastos más grandes"
   • "¿Cuánto gasté en comida?"

💡 **Obtener Consejos Financieros**
   • "¿Cómo puedo ahorrar más dinero?"
   • "¿Debería ajustar mis presupuestos de wave?"
   • "¿Algún consejo para reducir mis gastos?"

¿Qué te gustaría hacer?`,
      subtitle: "Tu Coach Financiero Personal",
      inputPlaceholder: "Pregúntale a Wavey lo que sea...",
      hint: 'Intenta preguntar: "¿Cuál es mi balance de Wave 2?" o "Agrega un gasto de $50"',
    },
    // Email Verification
    emailVerification: {
      checkYourEmail: "Revisa tu Correo",
      verificationLinkSent: "Enviamos un enlace de verificación a",
      clickLinkToActivate: "Haz clic en el enlace para activar tu cuenta.",
      didNotReceiveEmail: "¿No recibiste el correo?",
      resendEmail: "Reenviar Correo",
      sending: "Enviando...",
      verificationEmailSent:
        "¡Correo de verificación enviado! Revisa tu bandeja de entrada.",
      failedToResendEmail: "Error al reenviar correo. Inténtalo de nuevo.",
    },
    // Dashboard hook
    dashboardHook: {
      failedToFetchData: "Error al obtener datos",
    },
    // Subscription & Pricing
    subscription: {
      title: "Precios Simples y Transparentes",
      subtitle:
        "Elige el plan perfecto para tus necesidades de presupuesto. Actualiza en cualquier momento.",
      currentPlan: "Plan Actual: ",
      monthly: "Mensual",
      yearly: "Anual",
      save: "Ahorra 16-17%",
      free: "Gratis",
      standard: "Estándar",
      premium: "Premium",
      freeDescription: "Características esenciales",
      standardDescription: "Características profesionales",
      premiumDescription: "Características avanzadas",
      cancelPlan: "Cancelar Plan",
      downgrade: "Cambiar",
      upgrade: "Actualizar",
      selectPlan: "Seleccionar Plan",
      getStarted: "Comenzar",
      basicCharts: "Gráficos Básicos",
      advancedCharts: "Gráficos Avanzados",
      premiumSupport: "Soporte Premium",
      currentPlanLabel: "Plan Actual",
      plan: "Plan:",
      billing: "Facturación:",
      upgradeToPremium: "Actualizar a Premium",
      upgradeToStandard: "Actualizar a Estándar",
      featuresIncluded: "Lo Que Incluye",
      manageSubscription: "Administrar Suscripción",
      billingCycle: "Ciclo de Facturación",
      nextBillingDate: "Próxima Fecha de Facturación",
      planFeatures: "Características del Plan",
      unsafeContent: "Advertencia de contenido sensible",
      continueToPayment: "Continuar al Pago",
      confirmUpgrade: "Confirmar Actualización",
      confirmDowngrade: "Confirmar Cambio",
      upgradeSuccess: "¡Actualización exitosa!",
      downgradeSucess: "¡Cambio exitoso!",
      updateSuccess: "✅ Suscripción actualizada correctamente!",
      failedBillingPortal:
        "Error al abrir el portal de facturación. Intenta de nuevo.",
      cancelAtPeriodEnd: "✅ La suscripción se cancelará al final del periodo",
      failedCancelSubscription:
        "Error al cancelar la suscripción. Intenta de nuevo.",
      failedStartSubscription:
        "Error al iniciar la suscripción. Intenta de nuevo.",
      upgradePlan: "Actualiza tu Plan",
      viewPlans: "Ver Planes",
      manage: "Administrar",
      details: "Detalles de Suscripción",
      unlimitedExpenses: "Gastos Ilimitados",
      waveBudgeting: "Wave Budgeting",
      bankSyncing: "Sincronización Bancaria",
      customThemes: "Temas Personalizados",
      aiAdvisor: "Asesor IA",
      cancelWarning: "Tu suscripción se cancelará al final del periodo actual",
      updatePayment: "Actualizar Pago",
      billingHistory: "Historial de Facturación",
      noInvoices: "Aún no hay facturas",
      mostPopular: "Más Popular",
      faq: "Preguntas Frecuentes",
      faqCancel: "¿Puedo cancelar en cualquier momento?",
      faqCancelAnswer:
        "Sí, puedes cancelar tu suscripción en cualquier momento desde la configuración de tu cuenta.",
      faqRefunds: "¿Ofrecen reembolsos?",
      faqRefundsAnswer:
        "Los reembolsos están disponibles dentro de los 7 días posteriores a la compra.",
      faqMonthlyYearly: "¿Cuál es la diferencia entre mensual y anual?",
      faqMonthlyYearlyAnswer:
        "Los planes anuales te ahorran 16-17% comparado con pagar mes a mes. Se factura una vez al año.",
      backToDashboard: "← Volver al Panel",
      cancelDialogTitle: "¿Cancelar Suscripción?",
      cancelDialogContent:
        "Tu suscripción permanecerá activa hasta el final del periodo de facturación actual. Perderás acceso a las funciones premium después de eso.",
      keepSubscription: "Mantener Suscripción",
      yesCancel: "Sí, Cancelar",
      downgradeNotAvailable: "Cambio no disponible aún",
      approxMonthlyEquivalent: (monthly: number, saveText: string) =>
        `≈ $${monthly}/mes (${saveText})`,
      perMonth: "/mes",
      perYear: "/año",
      startFree: "Comenzar Gratis",
      trialBadge: "Prueba de 14 días • Cancela cuando quieras",
    },
    // Onboarding
    onboarding: {
      welcome: "¡Bienvenido a WaveBudget!",
      getStarted: "Comenzar",
      continueButton: "Continuar →",
      backButton: "← Atrás",
      skipButton: "Omitir",
      finishButton: "¡Comenzar!",
      step: "Paso",
      of: "de",
      setUpExpenses: "Configura Tus Gastos",
      addYourExpenses:
        "Agrega tus gastos regulares (renta, suscripciones, etc.)",
      trackingHelps:
        "El seguimiento te ayuda a mantener tu presupuesto bajo control",
      setUpIncome: "Configura Tu Ingreso",
      addYourIncome:
        "Agrega tus fuentes de ingreso (salario, trabajo freelance, etc.)",
      incomeHelps: "El ingreso ayuda a calcular tu saldo disponible",
      exploreDashboard: "Explora Tu Panel",
      viewCharts: "Ver gráficos, rastrear gastos y administrar tu presupuesto",
      trackOnly: "Solo Rastrear (Sin Fecha de Pago)",
      frequency: "Frecuencia",
      trackOnlyHint: "Rastrear este gasto sin una fecha de pago específica",
      expenseName: "Nombre del Gasto",
      expenseAmount: "Monto",
      category: "Categoría",
      wavePaycheck: "Wave (Quincenal)",
      paycheckCategory: "Nómina",
      otherCategory: "Otro (Único)",
      selectFrequency: "Seleccionar Frecuencia",
      weekly: "Semanal",
      biweekly: "Quincenal",
      monthly: "Mensual",
      oneTime: "Único",
      incomeSource: "Fuente de Ingreso",
      selectIncomeSource: "-- Seleccionar --",
      addExpense: "Agregar Gasto",
      addIncome: "Agregar Ingreso",
    },
    // Export Menu
    exportMenu: {
      exportData: "Exportar Datos",
      exportAsPDF: "Exportar como PDF",
      exportAsCSV: "Exportar como CSV",
      exportAsJSON: "Exportar como JSON",
      exportAsExcel: "Exportar como Excel",
      dataExportedPDF:
        "¡Reporte descargado! Ábrelo en el navegador e imprime como PDF.",
      dataExportedCSV: "¡Datos exportados a CSV exitosamente!",
      dataExportedJSON: "¡Datos exportados a JSON exitosamente!",
      dataExportedExcel: "¡Datos exportados a Excel exitosamente!",
    },
    // AI Modal
    aiModal: {
      requestsToday: "Consultas hoy:",
      remaining: "Restantes:",
      model: "Modelo:",
      aiWarning: "⚠️ Solo",
      aiWarningEnd: "consultas de IA restantes hoy",
      ask: "¡Pregúntame sobre cómo optimizar tu presupuesto, pagar deudas más rápido o administrar tus gastos!",
      poweredBy: "Impulsado por",
      you: "Tú",
      currentTierLimitReached: "Límite de nivel alcanzado",
      upgradeForMore: "Actualiza para más consultas",
      free: "GRATIS",
      standard: "ESTÁNDAR",
      premium: "PREMIUM",
    },
    // Mobile Menu
    mobileMenu: {
      menu: "Menú",
      exportData: "Exportar Datos",
      emailReport: "Enviar Reporte",
      resetAll: "Restablecer Todo",
      syncTransactions: "Sincronizar Transacciones",
      syncNow: "Sincronizar Ahora",
      cancel: "Cancelar",
      pushNotifications: "Notificaciones Push",
      bankSync: "Sincronización Bancaria",
      waveBudgetPro: "WaveBudget Pro",
      enable: "Habilitar",
      disable: "Deshabilitar",
      switchToDarkMode: "Cambiar a Modo Oscuro",
      switchToLightMode: "Cambiar a Modo Claro",
      banksLinked: "Banco(s) Vinculado(s)",
      syncing: "Sincronizando...",
      linkBankAccount: "Vincular Cuenta Bancaria",
      bankLinkedSuccess: "✅ ¡Banco vinculado exitosamente!",
      syncingYourTransactions: "Sincronizando tus transacciones...",
      successSynced: "¡Éxito! Sincronizadas",
      transactionsText: "transacciones",
      upgradeForBankSync: "Actualizar para Sincronización",
      transactionsSyncSuccess: "✅ ¡Transacciones sincronizadas exitosamente!",
      transactionsSyncFailed: "❌ Error al sincronizar transacciones",
      syncModalDescription:
        "Esto obtendrá tus últimas transacciones bancarias y actualizará tus gastos.",
      syncModalNote: "Puede tomar unos segundos.",
    },
    // Email Report Hook
    emailReport: {
      emailReport: "📧 Enviar Reporte",
      recipientEmail: "Correo Electrónico del Destinatario:",
      selectFormat: "Seleccionar Formato:",
      cancel: "Cancelar",
      send: "Enviar",
      noEmail: "Por favor ingresa un correo electrónico",
      invalidEmail: "Por favor ingresa un correo electrónico válido",
      reportSent: "Reporte enviado a",
      reportSentSuccess: "¡exitosamente!",
      failedToSend: "Error al enviar correo",
      pdf: "PDF",
      csv: "CSV",
      json: "JSON",
      excel: "Excel",
      example: "ejemplo@correo.com",
    },
    // Plaid Link Button
    plaidLink: {
      linkBankAccount: "Vincular Cuenta Bancaria",
      failedToConnect: "Error de conexión",
      connectingBank: "Conectando a tu banco...",
      selectAccount: "Seleccionar Cuenta",
      selectAccountToLink: "Selecciona la cuenta que deseas vincular",
      syncTransactions: "Sincronizar Transacciones",
      linkSuccess: "¡Banco vinculado exitosamente!",
      unlinkSuccess: "¡Banco desvinculado exitosamente!",
      bankLinkedSuccess:
        "✅ ¡Banco vinculado! {count} transacciones sincronizadas\nAgregados {incomes} ingresos y {expenses} gastos",
      bankLinkedSyncError:
        "Banco vinculado, pero no se pudieron sincronizar las transacciones. Intenta sincronizar manualmente.",
      failedToLink:
        "No se pudo vincular la cuenta bancaria. Por favor, inténtalo de nuevo.",
      unlinkBank: "Desvincular Banco",
      disconnectBank: "Desconectar Banco",
      unlinkBankConfirmTitle: "¿Desconectar Cuenta Bancaria?",
      unlinkBankConfirmMessage:
        "Esto desconectará tu banco y eliminará todos los gastos sincronizados por Plaid (pagos automáticos). Tus gastos agregados manualmente permanecerán. Esta acción no se puede deshacer.",
      unlinkingBank: "Desconectando...",
      failedToUnlink:
        "Error al desconectar el banco. Por favor, inténtalo de nuevo.",
      // Mensajes de error específicos
      errors: {
        itemLoginRequired:
          "Tu sesión bancaria ha expirado. Por favor, reconecta tu cuenta bancaria.",
        itemLocked:
          "Tu cuenta bancaria está bloqueada. Desbloquéala a través de tu banco e intenta de nuevo.",
        itemNotSupported:
          "Este banco ya no es compatible con nuestro servicio. Por favor, contacta con soporte.",
        apiError:
          "Servicio bancario temporalmente no disponible. Por favor, intenta de nuevo en unos minutos.",
        rateLimitExceeded:
          "Demasiadas solicitudes. Por favor, espera unos minutos antes de intentar de nuevo.",
        syncFailed:
          "Error al sincronizar transacciones. Por favor, intenta de nuevo.",
        genericError:
          "Ocurrió un error al conectar con tu banco. Por favor, intenta de nuevo.",
      },
      actions: {
        reconnect: "Reconectar Banco",
        retry: "Reintentar",
        dismiss: "Descartar",
        contactSupport: "Contactar Soporte",
      },
    },
    // Terms & Privacy
    termsPrivacy: {
      switchTo: "Cambiar a",
      spanish: "Español",
      english: "English",
      otherLanguage: "English",
      backToHome: "Volver al Inicio",
    },
    // Export Dialog (useExportDialog)
    exportDialog: {
      exportData: "Exportar Datos",
      downloadDescription:
        "Descargue sus datos de presupuesto en su formato preferido. Elija PDF para informes, CSV/Excel para hojas de cálculo o JSON para integración de datos.",
      selectExportFormat: "Seleccionar Formato de Exportación:",
      pdfReport: "Informe PDF",
      pdfDescription: "Informe profesional con gráficos y resúmenes",
      csvSpreadsheet: "Hoja de Cálculo CSV",
      csvDescription: "Formato universal compatible con Excel, Google Sheets",
      excelWorkbook: "Libro de Excel",
      excelDescription: "Formato Excel nativo con múltiples hojas y formato",
      jsonData: "Datos JSON",
      jsonDescription:
        "Formato de datos sin procesar para desarrolladores y análisis",
      cancel: "Cancelar",
      exporting: "Exportando...",
      download: "Descargar",
    },
    // Subscription
    subscriptionPage: {
      locale: "es-ES",
    },
    // Help Center
    helpCenter: {
      title: "Centro de Ayuda",
      subtitle: "Encuentra respuestas a preguntas comunes",
      contactSupport: "Contactar Soporte",
      email: "support@wavebudgettracker.com",
      placeholderEmail: "Tu correo (para que podamos responderte)",
      placeholderMessage: "Describe tu problema…",
      sendButton: "Enviar Mensaje",
      sending: "Enviando…",
      sent: "¡Mensaje Enviado!",
      sentNote: "¡Te responderemos pronto!",
      errorPrefix: "Error:",
      fillBothFields: "Por favor completa ambos campos.",
      failedToSend: "Error al enviar. Intenta de nuevo.",
      faqTitle: "Preguntas Frecuentes",
      supportRequestSubject: "Solicitud de Soporte desde Centro de Ayuda",
    },
    // Onboarding Steps
    onboardingSteps: {
      validAmount: "Por favor ingresa un monto válido",
      completeSuccess: "🎉 ¡Incorporación completa! ¡Bienvenido a WaveBudget!",
      completeError: "Error al completar la incorporación. Intenta de nuevo.",
      trackOnly: "Solo Rastrear (Sin Fecha de Pago)",
      frequency: "Frecuencia",
      incomeSource: "Fuente de Ingreso",
      selectDash: "-- Seleccionar --",
      waveBiweekly: "Wave (Quincenal)",
      paycheck: "Paycheck",
      otherOneTime: "Otro (Único)",
      continueButton: "Continuar →",
      backButton: "← Atrás",
      getStarted: "¡Comenzar!",
      step1Title: "Paso 1: Configura tu Monto de Ola",
      step1Description:
        "Tu 'Monto de Ola' es tu ingreso neto por cheque. Esta es la base de tu presupuesto. Organizaremos tus gastos alrededor de tus cheques (olas).",
      enterPaycheckAmount: "Ingresa el monto de tu cheque:",
      step2Title: "Paso 2: Agrega tu Primer Gasto",
      step2Description:
        "Agrega tus gastos regulares como renta, servicios, suscripciones. Te ayudaremos a organizarlos por programa de pago.",
      step2SampleDescription:
        "Haz clic en el botón '+ Agregar Nuevo Gasto' arriba para agregar tu primer gasto, luego regresa aquí.",
      step3Title: "Paso 3: Entendiendo las Olas",
      step3Description:
        "Una 'ola' es el período entre tus cheques. En lugar de categorías complicadas, WaveBudget organiza tus gastos por cuándo te pagan.",
      saveWaveError: "Error al guardar el monto de ola",
      validWaveAmount: "Por favor ingresa un monto de ola válido",
      welcomeTitle: "🌊 ¡Bienvenido a WaveBudget!",
      examplePaycheck:
        "💡 Ejemplo: Si te pagan $2,500 cada dos semanas, ingresa 2500",
      howWavesWork: "🌊 Cómo Funcionan las Olas:",
      paidBiweekly: "¿Te pagan quincenalmente? Tienes 2 olas por mes",
      paidWeekly: "¿Te pagan semanalmente? Tienes 4 olas por mes",
      assignedToWave:
        "Cada gasto se asigna a una ola según su fecha de vencimiento",
      seeAtGlance: "Ve de un vistazo cuánto te queda en cada ola",
    },
    // Expense Form additional
    expenseForm: {
      placeholder: "ej., Netflix",
      trackOnly: "Solo Rastrear (Sin Fecha de Pago)",
      incomeSource: "Fuente de Ingreso",
      selectDash: "-- Seleccionar --",
      waveBiweekly: "Wave (Quincenal)",
      paycheck: "Paycheck",
      otherOneTime: "Otro (Único)",
    },
    successMessages: {
      expenseAdded: "¡Gasto agregado exitosamente!",
      expenseUpdated: "¡Gasto actualizado exitosamente!",
      expenseDeleted: "¡Gasto eliminado exitosamente!",
      paymentConfirmed: "¡Pago confirmado y gasto marcado como pagado!",
      expensesReset: "¡Todos los gastos restablecidos a no pagados!",
      settingsUpdated: "¡Configuraciones actualizadas exitosamente!",
      incomeAdded: "¡Ingreso agregado!",
      incomeUpdated: "¡Ingreso actualizado!",
      incomeDeleted: "¡Ingreso eliminado!",
      bankSynced: "¡Transacciones bancarias sincronizadas exitosamente!",
    },
    errorMessages: {
      invalidFields:
        "Por favor completa todos los campos requeridos con valores válidos",
      invalidWave:
        "Por favor selecciona una ola válida (1 o 2) para la categoría Ola",
      invalidPaycheckFrequency:
        "Por favor selecciona una frecuencia de pago válida para la categoría Cheque de Pago",
      invalidPaycheckWave: (maxWaves: number, frequency: string) =>
        `Por favor selecciona una ola válida (1-${maxWaves}) para ${frequency === "weekly" ? "Semanal" : frequency === "biweekly" ? "Quincenal" : "Mensual"} Cheque de Pago`,
      invalidPaymentUrl:
        "Por favor ingresa una URL de pago o enlace profundo válido (e.g., https://www.chase.com o chase://pay)",
      noPaymentUrl: "No se proporcionó una URL de pago para este gasto",
      autopayManual:
        "Los gastos de pago automático no se pueden pagar manualmente",
      paymentNotConfirmed: "Pago no confirmado. El gasto permanece no pagado.",
      fetchExpensesFailed: "Error al obtener los gastos",
      saveExpenseFailed: "Error al guardar el gasto",
      updateExpenseFailed: "Error al actualizar el gasto",
      deleteExpenseFailed: "Error al eliminar el gasto",
      resetExpensesFailed: "Error al restablecer los gastos",
      fetchSettingsFailed: "Error al obtener las configuraciones",
      saveSettingsFailed: "Error al guardar las configuraciones",
      invalidIncomeFields:
        "Por favor completa todos los campos de ingreso correctamente",
      saveIncomeFailed: "Error al guardar ingreso",
      deleteIncomeFailed: "Error al eliminar ingreso",
      linkTokenFailed:
        "Error al generar token de enlace bancario. Intenta de nuevo.",
      tokenExchangeFailed:
        "Error al intercambiar token bancario. Intenta de nuevo.",
      syncFailed: "Error al sincronizar transacciones. Intenta de nuevo.",
      deleteExpensesFailed: "Error al eliminar gastos",
    },
    // Email Capture Landing Page
    emailCapture: {
      tagline: "ÚNETE A 500+ WAVE BUDGETERS",
      headline: '"¿Tengo Suficiente para la Hipoteca el Día 1?"',
      subheadline1:
        "Las aplicaciones de presupuesto tradicionales no podían responder esta pregunta.",
      subheadline2: "Así que construí algo diferente.",
      problemTitle: "El Problema con Todas las Apps de Presupuesto",
      problemDesc1:
        "Mi esposa trabaja como freelance. Yo tengo un salario fijo. Tenemos ingresos de renta, consultoría ocasional e ingresos de proyectos.",
      problemDesc2: "5 fuentes de ingreso diferentes",
      problemDesc3: "llegando en diferentes días, con diferentes montos.",
      ynabSays: 'YNAB: "Tienes $2,039 presupuestados para Vivienda"',
      realitySays:
        "Realidad: La hipoteca vence mañana. Solo tengo $1,200 en mi cuenta. Mi cheque no llega hasta el 5.",
      timingProblem:
        "La CATEGORÍA tenía dinero. Pero no lo tenía CUANDO lo necesitaba.",
      triedApps:
        "Probé YNAB. Probé Mint. Probé hojas de cálculo. Todas organizaban por",
      byMonth: "MES",
      byCategory: "CATEGORÍA",
      realProblem: "Pero el verdadero problema era el",
      timing: "TIEMPO",
      waveMethodTitle: "El Método Wave",
      waveMethodDesc: "En lugar de organizar por mes o categoría, organicé por",
      waves: "OLAS",
      step1: "Cada cheque = una nueva ola",
      step2:
        "Las facturas se asignan a la ola que llega antes de su vencimiento",
      step3:
        "Línea de tiempo visual muestra cuándo llega el dinero y cuándo vencen las facturas",
      isThisForYou: "¿Es Para Ti?",
      forYouTitle: "Esto es para ti si...",
      forYou1: "Pareja con doble ingreso (uno fijo, uno freelance)",
      forYou2: "Emprendedor con múltiples fuentes de ingreso",
      forYou3: "Ganas comisiones (base + variable)",
      forYou4: "Recibes 2+ pagos al mes",
      forYou5: 'Has preguntado: "¿Qué cheque cubre esta factura?"',
      notForYouTitle: "No es para ti si...",
      notForYou1: "Mismo monto de pago cada mes",
      notForYou2: "Todas las facturas en pago automático",
      notForYou3: "Tienes 6+ meses de fondo de emergencia",
      notForYou4: "Nunca te preocupas por el tiempo",
      stickWith: "Quédate con YNAB o Mint - funcionarán bien para ti.",
      resultsTitle: "Después de 12 Meses Usando el Método Wave",
      latePayments: "Pagos Atrasados",
      wasPerYear: "(eran 2-3/año)",
      overdraftFees: "Cargos por Sobregiro",
      partnerAlignment: "Alineación de Pareja",
      testimonial:
        '"Sabemos exactamente cuándo nos faltará - antes de que pase. Simplemente... funciona."',
      getGuideTitle: "Únete al Newsletter de WaveBudget",
      getGuideDesc:
        "Recibe tips semanales de presupuesto, estrategias de ahorro y actualizaciones",
      emailPlaceholder: "Ingresa tu correo electrónico...",
      getGuideButton: "Suscribirse",
      sending: "Suscribiendo...",
      noSpam: "Sin spam. Cancela cuando quieras.",
      weeklyTips: "Tips Semanales",
      moneySaving: "Ahorro",
      productUpdates: "Actualizaciones",
      featuresTitle: "Qué Hace Diferente a WaveBudget",
      featureWaveView: "Vista por Olas",
      featureWaveViewDesc:
        "Ve tu flujo de efectivo como línea de tiempo, no categorías",
      featurePayments: "Pagos con Un Toque",
      featurePaymentsDesc:
        "Paga facturas directamente desde la app con confirmación automática",
      featureFamily: "Compartir en Familia",
      featureFamilyDesc: "Ambos ven el mismo presupuesto en tiempo real",
      featureMobile: "Móvil + Web",
      featureMobileDesc:
        "Funciona en todos tus dispositivos, sincronizado automáticamente",
      featureAI: "Asesor Financiero IA",
      featureAIDesc: "Consulta sobre decisiones de dinero con guía inteligente",
      featureReports: "Reportes por Email",
      featureReportsDesc:
        "Resúmenes mensuales enviados a tu bandeja automáticamente",
      builtBy:
        "Creado por un Ingeniero Principal que lo necesitaba para su propia familia.",
      commits: "503 commits en 2024. Usado diariamente por mi familia.",
      tryFree: "Prueba WaveBudget Gratis",
      noCardRequired: "No se requiere tarjeta de crédito",
      successTitle: "¡Suscrito!",
      successDesc:
        "Bienvenido a la comunidad WaveBudget. Esto es lo que recibirás:",
      benefit1Title: "Tips Semanales de Presupuesto",
      benefit1Desc: "Estrategias prácticas para dominar el tiempo de tu dinero",
      benefit2Title: "Estrategias de Ahorro",
      benefit2Desc: "Tips exclusivos de hogares con múltiples ingresos",
      benefit3Title: "Actualizaciones del Producto",
      benefit3Desc:
        "Sé el primero en conocer las nuevas funciones de WaveBudget",
    },
  },
};

// Utility function to get wave label
export const getWaveLabel = (
  wave: number,
  frequency: string,
  t: typeof translations.en,
) => {
  if (frequency === "weekly") {
    return t.week(wave);
  }
  return t.wave(wave);
};
